webpackJsonp([1,0],[
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _vue = __webpack_require__(89);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _App = __webpack_require__(76);
	
	var _App2 = _interopRequireDefault(_App);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	window.vdesigner = new _vue2.default({
	  el: 'body',
	  components: { App: _App2.default }
	});

/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_script__, __vue_template__
	var __vue_styles__ = {}
	__vue_script__ = __webpack_require__(30)
	__vue_template__ = __webpack_require__(75)
	module.exports = __vue_script__ || {}
	if (module.exports.__esModule) module.exports = module.exports.default
	var __vue_options__ = typeof module.exports === "function" ? (module.exports.options || (module.exports.options = {})) : module.exports
	if (__vue_template__) {
	__vue_options__.template = __vue_template__
	}
	if (!__vue_options__.computed) __vue_options__.computed = {}
	Object.keys(__vue_styles__).forEach(function (key) {
	var module = __vue_styles__[key]
	__vue_options__.computed[key] = function () { return module }
	})


/***/ }),
/* 2 */,
/* 3 */,
/* 4 */
/***/ (function(module, exports) {

	module.exports = jQuery;

/***/ }),
/* 5 */,
/* 6 */,
/* 7 */,
/* 8 */,
/* 9 */,
/* 10 */,
/* 11 */,
/* 12 */,
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_script__, __vue_template__
	var __vue_styles__ = {}
	__vue_script__ = __webpack_require__(28)
	__vue_template__ = __webpack_require__(73)
	module.exports = __vue_script__ || {}
	if (module.exports.__esModule) module.exports = module.exports.default
	var __vue_options__ = typeof module.exports === "function" ? (module.exports.options || (module.exports.options = {})) : module.exports
	if (__vue_template__) {
	__vue_options__.template = __vue_template__
	}
	if (!__vue_options__.computed) __vue_options__.computed = {}
	Object.keys(__vue_styles__).forEach(function (key) {
	var module = __vue_styles__[key]
	__vue_options__.computed[key] = function () { return module }
	})


/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_script__, __vue_template__
	var __vue_styles__ = {}
	__vue_script__ = __webpack_require__(29)
	__vue_template__ = __webpack_require__(74)
	module.exports = __vue_script__ || {}
	if (module.exports.__esModule) module.exports = module.exports.default
	var __vue_options__ = typeof module.exports === "function" ? (module.exports.options || (module.exports.options = {})) : module.exports
	if (__vue_template__) {
	__vue_options__.template = __vue_template__
	}
	if (!__vue_options__.computed) __vue_options__.computed = {}
	Object.keys(__vue_styles__).forEach(function (key) {
	var module = __vue_styles__[key]
	__vue_options__.computed[key] = function () { return module }
	})


/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _stringify = __webpack_require__(2);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _keys = __webpack_require__(31);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _Fabric = __webpack_require__(84);
	
	var _Fabric2 = _interopRequireDefault(_Fabric);
	
	var _Buttons = __webpack_require__(78);
	
	var _Buttons2 = _interopRequireDefault(_Buttons);
	
	var _Fit = __webpack_require__(85);
	
	var _Fit2 = _interopRequireDefault(_Fit);
	
	var _Collar = __webpack_require__(80);
	
	var _Collar2 = _interopRequireDefault(_Collar);
	
	var _Cuff = __webpack_require__(83);
	
	var _Cuff2 = _interopRequireDefault(_Cuff);
	
	var _Bags = __webpack_require__(77);
	
	var _Bags2 = _interopRequireDefault(_Bags);
	
	var _Monogramm = __webpack_require__(87);
	
	var _Monogramm2 = _interopRequireDefault(_Monogramm);
	
	var _Hankerchief = __webpack_require__(86);
	
	var _Hankerchief2 = _interopRequireDefault(_Hankerchief);
	
	var _Yarnbuttonhole = __webpack_require__(88);
	
	var _Yarnbuttonhole2 = _interopRequireDefault(_Yarnbuttonhole);
	
	var _Contrastjumper = __webpack_require__(82);
	
	var _Contrastjumper2 = _interopRequireDefault(_Contrastjumper);
	
	var _ContrastCollarOutside = __webpack_require__(81);
	
	var _ContrastCollarOutside2 = _interopRequireDefault(_ContrastCollarOutside);
	
	var _Checkout = __webpack_require__(79);
	
	var _Checkout2 = _interopRequireDefault(_Checkout);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var jQuery = __webpack_require__(4);
	
	exports.default = {
	  components: {
	    Fabric: _Fabric2.default,
	    Buttons: _Buttons2.default,
	    Fit: _Fit2.default,
	    Collar: _Collar2.default,
	    Cuff: _Cuff2.default,
	    Bags: _Bags2.default,
	    Monogramm: _Monogramm2.default,
	    Hankerchief: _Hankerchief2.default,
	    Yarnbuttonhole: _Yarnbuttonhole2.default,
	    Contrastjumper: _Contrastjumper2.default,
	    ContrastCollarOutside: _ContrastCollarOutside2.default,
	    Checkout: _Checkout2.default
	  },
	  data: function data() {
	    return {
	      is_touch_device: 'ontouchstart' in window || navigator.maxTouchPoints,
	      currentView: 'fabric',
	      count: 0,
	      msg: Object,
	      flash: Object,
	      priceExtra: '9.90',
	      session: Object,
	      buttonPrice: 0,
	      buttonsection: 1,
	      buttons: [],
	      loginurl: window.shirtdesigner.loginurl,
	      price: window.shirtdesigner['priceClassic'],
	      priceInfo: window.shirtdesigner.priceInfo,
	      baseurl: window.shirtdesigner['baseurl'],
	      measurementUrl: window.shirtdesigner['measurementUrl'],
	      invurl: window.shirtdesigner.invurl,
	      isloggedin: window.shirtdesigner.loggedin,
	      measurementblock: window.shirtdesigner.measurementblock,
	      imgcaption: window.shirtdesigner.translations.imgcaption,
	      seoblock: window.shirtdesigner.translations.seoBlock,
	      addToCartText: window.shirtdesigner.translations['Add to Cart'],
	      translations: window.shirtdesigner.translations,
	      views: ['fabric', 'fit', 'lowercut', 'sleeve', 'collar', 'cuff', 'buttons', 'front', 'back', 'bags', 'monogramm', 'hankerchief', 'yarncontrast', 'yarnbuttonhole', 'contrastjumper', 'contrast_bs_upper_outside', 'contrast_bs_upper_inside', 'contrast_bs_bottom_outside', 'contrast_collar_outside', 'contrast_collar_bottom', 'contrast_collar_stand_outer', 'contrast_collar_stand_inner', 'contrast_cuff_outside', 'contrast_cuff_inside', 'contrast_sleeve_buttons_outside', 'contrast_sleeve_buttons_inside', 'checkout'],
	      personal: { 'fabric': 'Twill-1', 'fabric_quality': 'classic', 'fit': 'normal', 'lowercut': 'curved', 'sleeve': 'long', 'collar': 'kent', 'collarbuttons': 'onebutton', 'collar_height': '4', 'collar_strength': 'solid', 'cuff': 'squaresingle', 'cuffwidth': '', 'front': 'normal', 'buttons': 'button_01', 'button-color': 'default', 'bags': 'none', 'bagsposition': 'left', 'back': 'flat', 'monogramm': 'no_monogramm', 'monopos': 'waistleft', 'monogramm_yarn': 'neutral', 'monogramm_font': 'block', 'monogramm-color': '000000', 'yarn-color': 'neutral', 'yarncontrast': 'neutral', 'yarnbuttonhole': 'neutral', 'contrast_collar_outside': 'none', 'contrast_collar_bottom': 'none', 'contrast_collar_stand_outer': 'none', 'contrast_collar_stand_inner': 'none', 'contrast_cuff_outside': 'none', 'contrast_cuff_inside': 'none', 'hankerchief': 'none', 'tj_logo': 'yes', 'outsize': 'none', 'contrast_sleeve_buttons_outside': 'none', 'contrast_sleeve_buttons_inside': 'none', 'contrast_bs_upper_outside': 'none', 'contrast_bs_upper_inside': 'none', 'contrast_bs_bottom_outside': 'none', 'topseller': '0', 'configure_id': '0' },
	      defaults: { 'fabric': 'Twill-1', 'fabric_quality': 'classic', 'fit': 'normal', 'lowercut': 'curved', 'sleeve': 'long', 'collar': 'kent', 'collarbuttons': 'onebutton', 'collar_height': '4', 'collar_strength': 'solid', 'cuff': 'squaresingle', 'cuffwidth': '', 'front': 'normal', 'buttons': 'button_01', 'button-color': 'default', 'bags': 'none', 'bagsposition': 'left', 'back': 'flat', 'monogramm': 'no_monogramm', 'monopos': 'waistleft', 'monogramm_yarn': 'neutral', 'monogramm_font': 'block', 'monogramm-color': '000000', 'yarn-color': 'neutral', 'yarncontrast': 'neutral', 'yarnbuttonhole': 'neutral', 'contrast_collar_outside': 'none', 'contrast_collar_bottom': 'none', 'contrast_collar_stand_outer': 'none', 'contrast_collar_stand_inner': 'none', 'contrast_cuff_outside': 'none', 'contrast_cuff_inside': 'none', 'hankerchief': 'none', 'tj_logo': 'yes', 'outsize': 'none', 'contrast_sleeve_buttons_outside': 'none', 'contrast_sleeve_buttons_inside': 'none', 'contrast_bs_upper_outside': 'none', 'contrast_bs_upper_inside': 'none', 'contrast_bs_bottom_outside': 'none', 'topseller': '0', 'configure_id': '0' },
	      steps: ['Stoff'],
	      fabrics: [],
	      designName: 'Mein Design',
	      design: [],
	      designId: window.shirtdesigner.designId,
	      selectItems: [],
	      selectBox: [],
	      zoom: { img: '', title: '', text: '', price: '' },
	      stepValue: [],
	      sleevesShort: false,
	      selectBoxes: {
	        'fit': { 'component': 'fit', 'title': window.shirtdesigner.translations['Fit'], 'todo': window.shirtdesigner.translations['Choose the correct fit'], 'active': true },
	        'lowercut': { 'component': 'lowercut', 'title': window.shirtdesigner.translations['Lower Cut'], 'todo': window.shirtdesigner.translations['Choose the lower cut'], 'active': true },
	        'sleeve': { 'component': 'sleeve', 'title': window.shirtdesigner.translations['Sleeve'], 'todo': window.shirtdesigner.translations['Choose a sleeve form'], 'active': true },
	        'collar': { 'component': 'collar', 'title': window.shirtdesigner.translations['Collar'], 'todo': window.shirtdesigner.translations['Choose a collar type'] + ' ' + window.shirtdesigner.translations['You can choose between number of collar buttons, collar height and strength.'], 'active': true },
	        'cuff': { 'component': 'cuff', 'title': window.shirtdesigner.translations['Cuff'], 'todo': window.shirtdesigner.translations['Choose a cuff type'], 'active': true },
	        'buttons': { 'component': 'buttons', 'extra': '0,00', 'title': window.shirtdesigner.translations['Buttons'], 'todo': window.shirtdesigner.translations['Choose your Buttons'], 'active': true },
	        'front': { 'component': 'front', 'title': window.shirtdesigner.translations['Placket'], 'todo': window.shirtdesigner.translations['Choose Placket'], 'active': true },
	        'back': { 'component': 'back', 'title': window.shirtdesigner.translations['Back-Design'], 'todo': window.shirtdesigner.translations['Choose Back-Design'], 'active': true },
	        'bags': { 'component': 'bags', 'title': window.shirtdesigner.translations['Bags'], 'todo': window.shirtdesigner.translations['Choose Bags'], 'active': true },
	        'monogramm': { 'component': 'monogramm', 'extra': window.shirtdesigner.extraPrices['monogramm'], 'title': window.shirtdesigner.translations['Monogram'], 'todo': window.shirtdesigner.translations['4 steps to your monogram:'] + '<br/><br/>' + window.shirtdesigner.translations['1. Enter monogram (max. 3 chars and 3 points)'] + '<br/>' + window.shirtdesigner.translations['2. Select font'] + '<br/>' + window.shirtdesigner.translations['3. Select position'] + '<br/>' + window.shirtdesigner.translations['4. Select yarn color'] + '<br/><br/>' + window.shirtdesigner.translations['If you don`t want to have a monogram, just leave field empty.'], 'active': true },
	        'hankerchief': { 'component': 'hankerchief', 'extra': window.shirtdesigner.extraPrices['hankerchief'], 'title': window.shirtdesigner.translations['Hankerchief'], 'todo': window.shirtdesigner.translations['Order the matching handkerchief in your shirt color'], 'active': true },
	        'yarncontrast': { 'component': 'yarncontrast', 'extra': window.shirtdesigner.extraPrices['yarncontrast'], 'title': window.shirtdesigner.translations['Yarn Contrast Suture'], 'todo': window.shirtdesigner.translations['Choose a Contrast-Yarn for sutures.'] + '<br/>' + window.shirtdesigner.translations['Note: Neutral means a yarn is chosen according to fabric'] + '<br/>' + window.shirtdesigner.translations['Display: Take a look at the picture below.'], 'active': true },
	        'yarnbuttonhole': { 'component': 'yarnbuttonhole', 'extra': window.shirtdesigner.extraPrices['yarnbuttonhole'], 'title': window.shirtdesigner.translations['Yarn Buttonhole'], 'todo': window.shirtdesigner.translations['Choose a Contrast-Yarn for buttonholes'] + '<br/>' + window.shirtdesigner.translations['Note: Neutral means a yarn is chosen according to fabric'], 'active': true },
	        'contrastjumper': { 'component': 'contrastjumper', 'title': window.shirtdesigner.translations['Contrast Fabrics'], 'todo': window.shirtdesigner.translations['Do you want to skip contrast fabrics?'], 'active': true },
	        'contrast_bs_upper_outside': { 'component': 'contrast_bs_upper_outside', 'extra': window.shirtdesigner.extraPrices['contrast_bs_upper_outside'], 'title': window.shirtdesigner.translations['Upper Button Strip (outside)'], 'todo': window.shirtdesigner.translations['Choose a contrast fabric for the upper button strip (outside).'], 'active': true },
	        'contrast_bs_upper_inside': { 'component': 'contrast_bs_upper_inside', 'extra': window.shirtdesigner.extraPrices['contrast_bs_upper_inside'], 'title': window.shirtdesigner.translations['Upper Button Strip (inside)'], 'todo': window.shirtdesigner.translations['Choose a contrast fabric for the upper button strip (inside).'] + '<br/>' + window.shirtdesigner.translations['Display: Take a look at the picture below.'], 'active': true },
	        'contrast_bs_bottom_outside': { 'component': 'contrast_bs_bottom_outside', 'extra': window.shirtdesigner.extraPrices['contrast_bs_bottom_outside'], 'title': window.shirtdesigner.translations['Lower Button Strip (outside)'], 'todo': window.shirtdesigner.translations['Choose a contrast fabric for the lower button strip (outside).'] + '<br/>' + window.shirtdesigner.translations['Display: Take a look at the picture below.'], 'active': true },
	        'contrast_collar_outside': { 'component': 'contrast_collar_outside', 'extra': window.shirtdesigner.extraPrices['contrast_collar_outside'], 'title': window.shirtdesigner.translations['Collar Outside'], 'todo': window.shirtdesigner.translations['Choose a contrast fabric for the outer collar'], 'active': true },
	        'contrast_collar_bottom': { 'component': 'contrast_collar_bottom', 'extra': window.shirtdesigner.extraPrices['contrast_collar_bottom'], 'title': window.shirtdesigner.translations['Collar Bottom'], 'todo': window.shirtdesigner.translations['Choose a contrast fabric for the lower collar'] + '<br/>' + window.shirtdesigner.translations['Display: Take a look at the picture below.'], 'active': true },
	        'contrast_collar_stand_outer': { 'component': 'contrast_collar_stand_outer', 'extra': window.shirtdesigner.extraPrices['contrast_collar_stand_outer'], 'title': window.shirtdesigner.translations['Collar Outer-Stand'], 'todo': window.shirtdesigner.translations['Choose a contrast fabric for the outer collar stand'] + '<br/>' + window.shirtdesigner.translations['Display: Take a look at the picture below.'], 'active': true },
	        'contrast_collar_stand_inner': { 'component': 'contrast_collar_stand_inner', 'extra': window.shirtdesigner.extraPrices['contrast_collar_stand_inner'], 'title': window.shirtdesigner.translations['Collar Inner-Stand'], 'todo': window.shirtdesigner.translations['Choose a contrast fabric for the inner collar stand'] + '<br/>' + window.shirtdesigner.translations['Display: Take a look at the picture below.'], 'active': true },
	        'contrast_cuff_outside': { 'component': 'contrast_cuff_outside', 'extra': window.shirtdesigner.extraPrices['contrast_cuff_outside'], 'title': window.shirtdesigner.translations['Cuff Outside'], 'todo': window.shirtdesigner.translations['Choose a contrast fabric for the outer cuff'], 'active': true },
	        'contrast_cuff_inside': { 'component': 'contrast_cuff_inside', 'extra': window.shirtdesigner.extraPrices['contrast_cuff_inside'], 'title': window.shirtdesigner.translations['Cuff Inside'], 'todo': window.shirtdesigner.translations['Choose a contrast fabric for the inner cuff'], 'active': true },
	        'contrast_sleeve_buttons_outside': { 'component': 'contrast_sleeve_buttons_outside', 'extra': window.shirtdesigner.extraPrices['contrast_sleeve_buttons_outside'], 'title': window.shirtdesigner.translations['Cuff Outer Button Strip'], 'todo': window.shirtdesigner.translations['Choose a contrast fabric for the outer button strip (cuff).'] + '<br/>' + window.shirtdesigner.translations['Display: Take a look at the picture below.'], 'active': true },
	        'contrast_sleeve_buttons_inside': { 'component': 'contrast_sleeve_buttons_inside', 'extra': window.shirtdesigner.extraPrices['contrast_sleeve_buttons_inside'], 'title': window.shirtdesigner.translations['Cuff Inner Button Strip'], 'todo': window.shirtdesigner.translations['Choose a contrast fabric for the inner button strip (cuff).'] + '<br/>' + window.shirtdesigner.translations['Display: Take a look at the picture below.'], 'active': true },
	        'checkout': { 'component': 'checkout', 'title': window.shirtdesigner.translations['Maße & Kaufen'], 'todo': '', 'active': true }
	      },
	      selectBoxItems: {
	        'fit': [{ 'ref_number': 'fitted', 'thumb': 'jack/shirt/thumb/fit_fitted.jpg', 'name': window.shirtdesigner.translations['_1Fitted'], 'infotext': window.shirtdesigner.translations['Fit Fitted Description'] }, { 'ref_number': 'normal', 'thumb': 'jack/shirt/thumb/fit_normal.jpg', 'name': window.shirtdesigner.translations['Normal'], 'infotext': window.shirtdesigner.translations['Fit Normal Description'] }, { 'ref_number': 'comfort', 'thumb': 'jack/shirt/thumb/fit_comfort.jpg', 'name': window.shirtdesigner.translations['Comfort'], 'infotext': window.shirtdesigner.translations['Fit Comfort Description'] }],
	        'lowercut': [{ 'ref_number': 'curved', 'thumb': 'jack/shirt/thumb/lowercut_curved.jpg', 'name': window.shirtdesigner.translations['Curved'], 'infotext': window.shirtdesigner.translations['Lowercut Curved Description'] }, { 'ref_number': 'straight', 'thumb': 'jack/shirt/thumb/lowercut_straight.jpg', 'name': window.shirtdesigner.translations['Straight'], 'infotext': window.shirtdesigner.translations['Lowercut Straight Description'] }],
	        'sleeve': [{ 'ref_number': 'long', 'thumb': 'jack/shirt/thumb/sleeve_long.jpg', 'name': window.shirtdesigner.translations['Long'], 'infotext': window.shirtdesigner.translations['Sleeve Long Description'] }, { 'ref_number': 'short', 'thumb': 'jack/shirt/thumb/sleeve_short.jpg', 'name': window.shirtdesigner.translations['Short'], 'infotext': window.shirtdesigner.translations['Sleeve Short Description'] }, { 'ref_number': 'shortbar', 'thumb': 'jack/shirt/thumb/sleeve_shortbar.jpg', 'name': window.shirtdesigner.translations['Short with Bar'], 'infotext': window.shirtdesigner.translations['Sleeve Shortbar Description'] }],
	        'collar': [{ 'ref_number': 'kent', 'thumb': 'jack/shirt/thumb/collar_kent.jpg', 'name': window.shirtdesigner.translations['Kent'] }, { 'ref_number': 'buttondown', 'thumb': 'jack/shirt/thumb/collar_buttondown.jpg', 'name': window.shirtdesigner.translations['Button-Down'] }, { 'ref_number': 'shark', 'thumb': 'jack/shirt/thumb/collar_shark.jpg', 'name': window.shirtdesigner.translations['Shark'] }, { 'ref_number': 'kentsmall', 'thumb': 'jack/shirt/thumb/collar_kentsmall.jpg', 'name': window.shirtdesigner.translations['Small Kent'] }, { 'ref_number': 'buttondownsmall', 'thumb': 'jack/shirt/thumb/collar_buttondownsmall.jpg', 'name': window.shirtdesigner.translations['Small Button-Down'] }, { 'ref_number': 'sharksmall', 'thumb': 'jack/shirt/thumb/collar_sharksmall.jpg', 'name': window.shirtdesigner.translations['Small Shark'] }, { 'ref_number': 'tab', 'thumb': 'jack/shirt/thumb/collar_tab.jpg', 'name': window.shirtdesigner.translations['Tab'] }, { 'ref_number': 'windsor', 'thumb': 'jack/shirt/thumb/collar_windsor.jpg', 'name': window.shirtdesigner.translations['Windsor'] }, { 'ref_number': 'standup', 'thumb': 'jack/shirt/thumb/collar_standup.jpg', 'name': window.shirtdesigner.translations['Stand-Up'] }, { 'ref_number': 'london', 'thumb': 'jack/shirt/thumb/collar_london.jpg', 'name': window.shirtdesigner.translations['London'] }, { 'ref_number': 'napolishark', 'thumb': 'jack/shirt/thumb/collar_napolishark.jpg', 'name': window.shirtdesigner.translations['Napoli Shark'] }, { 'ref_number': 'smoking', 'thumb': 'jack/shirt/thumb/collar_smoking.jpg', 'name': window.shirtdesigner.translations['Smoking'] }],
	        'cuff': [{ 'ref_number': 'squaresingle', 'thumb': 'jack/shirt/thumb/cuff_squaresingle.jpg', 'name': window.shirtdesigner.translations['Square 1-Button'] }, { 'ref_number': 'squaredouble', 'thumb': 'jack/shirt/thumb/cuff_squaredouble.jpg', 'name': window.shirtdesigner.translations['Square 2-Button'] }, { 'ref_number': 'squaretripple', 'thumb': 'jack/shirt/thumb/cuff_squaretripple.jpg', 'name': window.shirtdesigner.translations['Square 3-Button'] }, { 'ref_number': 'roundsingle', 'thumb': 'jack/shirt/thumb/cuff_roundsingle.jpg', 'name': window.shirtdesigner.translations['Round 1-Button'] }, { 'ref_number': 'rounddouble', 'thumb': 'jack/shirt/thumb/cuff_rounddouble.jpg', 'name': window.shirtdesigner.translations['Round 2-Button'] }, { 'ref_number': 'roundenv', 'thumb': 'jack/shirt/thumb/cuff_roundenv.jpg', 'name': window.shirtdesigner.translations['Round Envelope'] }, { 'ref_number': 'straightsingle', 'thumb': 'jack/shirt/thumb/cuff_straightsingle.jpg', 'name': window.shirtdesigner.translations['Straigth 1-Button'] }, { 'ref_number': 'straightdouble', 'thumb': 'jack/shirt/thumb/cuff_straightdouble.jpg', 'name': window.shirtdesigner.translations['Straigth 2-Button'] }],
	        'buttons': [],
	        'front': [{ 'ref_number': 'normal', 'thumb': 'jack/shirt/thumb/front_normal.jpg', 'name': window.shirtdesigner.translations['Normal'] }, { 'ref_number': 'sewed', 'thumb': 'jack/shirt/thumb/front_sewed.jpg', 'name': window.shirtdesigner.translations['Sewed'] }, { 'ref_number': 'hidden', 'thumb': 'jack/shirt/thumb/front_hidden.jpg', 'name': window.shirtdesigner.translations['Hidden'] }],
	        'back': [{ 'ref_number': 'flat', 'thumb': 'jack/shirt/thumb/back_flat.jpg', 'name': window.shirtdesigner.translations['_1Flat'] }, { 'ref_number': 'middle', 'thumb': 'jack/shirt/thumb/back_middle.jpg', 'name': window.shirtdesigner.translations['Middle'] }, { 'ref_number': 'sidedart', 'thumb': 'jack/shirt/thumb/back_sidedart.jpg', 'name': window.shirtdesigner.translations['Side-Dart'] }],
	        'bags': [{ 'ref_number': 'none', 'thumb': 'upload/image/dummy_product_small.jpg', 'name': window.shirtdesigner.translations['None'] }, { 'ref_number': 'ustyle', 'thumb': 'jack/shirt/thumb/bags_ustyle.jpg', 'name': window.shirtdesigner.translations['U-Style'] }, { 'ref_number': 'vstyle', 'thumb': 'jack/shirt/thumb/bags_vstyle.jpg', 'name': window.shirtdesigner.translations['V-Style'] }],
	        'monogramm': [],
	        'hankerchief': [],
	        'yarncontrast': [],
	        'yarnbuttonhole': [],
	        'contrastjumper': [],
	        'contrast_bs_upper_outside': [],
	        'contrast_bs_upper_inside': [],
	        'contrast_bs_bottom_outside': [],
	        'contrast_collar_outside': [],
	        'contrast_collar_bottom': [],
	        'contrast_collar_stand_outer': [],
	        'contrast_collar_stand_inner': [],
	        'contrast_cuff_outside': [],
	        'contrast_cuff_inside': [],
	        'contrast_sleeve_buttons_outside': [],
	        'contrast_sleeve_buttons_inside': []
	      },
	      'summary': [],
	      'currentStep': '',
	      'currentPrice': '',
	      'showModal': false,
	      'currentExtraPrices': {},
	      'muster1': JSON.parse(localStorage.getItem('muster1')),
	      'muster2': JSON.parse(localStorage.getItem('muster2')),
	      'muster3': JSON.parse(localStorage.getItem('muster3')),
	      'muster4': JSON.parse(localStorage.getItem('muster4'))
	    };
	  },
	  created: function created() {
	    var changedStep = 0;
	    var c = localStorage.getItem('currentViewShirt');
	    if (localStorage.getItem('shirtIsTopseller') > 0) {
	      localStorage.setItem('shirtIsTopseller', 0);
	      changedStep = this.views.length - 2;
	    } else if (localStorage.getItem('shirt_configure_id') > 0) {
	      this.personal['configure_id'] = localStorage.getItem('shirt_configure_id');
	      localStorage.setItem('shirt_configure_id', 0);
	      changedStep = this.views.length - 1;
	    } else {
	      for (var j = 0; j < this.personal.length; j++) {
	        if (this.personal[j] !== this.defaults[j]) {
	          changedStep = j;
	        }
	      }
	      if (c > changedStep) {
	        changedStep = c;
	      }
	    }
	    this.personal = this.getPersonalData();
	    if (c) {
	      for (var i = 1; i <= changedStep; i++) {
	        this.addStep(i);
	        this.updateSteps(i - 1);
	      }
	      this.gotoStep(c);
	    }
	
	    if (this.isloggedin !== 'false') {
	      jQuery.post(this.baseurl + 'designer/ajax/loadSession', { type: 'shirt' }, function (data) {
	        this.session = JSON.parse(data);
	        this.design = this.session.configuration;
	        this.loadDesignData(this.design);
	        this.updatePrice();
	      }.bind(this));
	    }
	    jQuery.getJSON(window.shirtdesigner['baseurl'] + '/designer/ajax/getButtonList', { target: 'button', type: 'shirt' }, function (data) {
	      this.buttons = data;
	      this.updatePrice();
	    }.bind(this));
	    this.setMobileTitle();
	    this.updateMonogrammPosition(this.personal['monopos']);
	  },
	  computed: {
	    monogrammUrl: function monogrammUrl() {
	      return window.shirtdesigner['monogrammImageURL'] + '/color/' + this.personal['monogramm-color'] + '/text/' + this.personal['monogramm'] + '/pos/' + this.personal['monopos'] + '.png';
	    },
	    frontUrl: function frontUrl() {
	      return window.shirtdesigner['compositeUrl'] + '/cps/front/texture/' + this.personal['fabric'] + '/mask/front_sewed.png';
	    },
	    buttonStripeUrl: function buttonStripeUrl() {
	      return window.shirtdesigner['compositeUrl'] + '/cps/front/texture/' + this.personal['contrast_bs_upper_outside'] + '/mask/button_stripe_' + this.personal['lowercut'] + '.png';
	    },
	    cuffUrl: function cuffUrl() {
	      return window.shirtdesigner['compositeUrl'] + '/cps/cuff/texture/' + (this.personal['contrast_cuff_outside'] === 'none' ? this.personal['fabric'] : this.personal['contrast_cuff_outside']) + '/mask/cuff_' + this.personal['cuff'] + '.png';
	    },
	    cuffInnerUrl: function cuffInnerUrl() {
	      return window.shirtdesigner['compositeUrl'] + '/cps/cuffinner/texture/' + (this.personal['cuff'] === 'roundenv' ? this.personal['contrast_cuff_outside'] === 'none' ? this.personal['fabric'] : this.personal['contrast_cuff_outside'] : this.personal['contrast_cuff_inside'] === 'none' ? this.personal['fabric'] : this.personal['contrast_cuff_inside']) + '/mask/mask_cuff_inner_' + this.personal['cuff'] + '.png';
	    },
	    fitUrl: function fitUrl() {
	      return window.shirtdesigner['compositeUrl'] + '/cps/fit/texture/' + this.personal['fabric'] + '/mask/fit_' + this.personal['fit'] + '_' + this.personal['lowercut'] + '.png';
	    },
	    buttonsFrontUrl: function buttonsFrontUrl() {
	      return window.shirtdesigner['colorizeImageURL'] + '/color/' + this.personal['button-color'] + '/img/mask_buttons_front.png';
	    },
	    sleeveUrl: function sleeveUrl() {
	      return window.shirtdesigner['compositeUrl'] + '/cps/sleeve/texture/' + this.personal['fabric'] + '/mask/sleeve_' + this.personal['sleeve'] + '.png';
	    },
	    buttonsCuffUrl: function buttonsCuffUrl() {
	      return window.shirtdesigner['colorizeImageURL'] + '/color/' + this.personal['button-color'] + '/img/mask_buttons_cuff_' + this.personal['cuff'] + '.png';
	    },
	    buttonsCollarUrl: function buttonsCollarUrl() {
	      return window.shirtdesigner['colorizeImageURL'] + '/color/' + this.personal['button-color'] + '/img/mask_buttons_collar_' + this.personal['collar'] + '.png';
	    },
	    yarnFrontUrl: function yarnFrontUrl() {
	      return window.shirtdesigner['colorizeImageURL'] + '/color/' + this.personal['yarnbuttonhole'] + '/img/mask_yarn_front.png';
	    },
	    yarnCuffUrl: function yarnCuffUrl() {
	      return window.shirtdesigner['colorizeImageURL'] + '/color/' + this.personal['yarnbuttonhole'] + '/img/mask_yarn_cuff_' + this.personal['cuff'] + '.png';
	    },
	    yarnCollarUrl: function yarnCollarUrl() {
	      return window.shirtdesigner['colorizeImageURL'] + '/color/' + this.personal['yarnbuttonhole'] + '/img/mask_yarn_collar_' + this.personal['collar'] + '.png';
	    },
	    collarWingsUrl: function collarWingsUrl() {
	      return window.shirtdesigner['compositeUrl'] + '/cps/collarwing/texture/' + (this.personal['contrast_collar_outside'] === 'none' ? this.personal['fabric'] : this.personal['contrast_collar_outside']) + '/mask/mask_collar_wings_' + this.personal['collar'] + '.png';
	    },
	    collarStandUrl: function collarStandUrl() {
	      return window.shirtdesigner['compositeUrl'] + '/cps/collarinnerback/texture/' + this.personal['fabric'] + '/mask/mask_collar_inner_back.png';
	    },
	    collarInnerStandUrl: function collarInnerStandUrl() {
	      return window.shirtdesigner['compositeUrl'] + '/cps/collarinnerstand/texture/' + (this.personal['contrast_collar_stand_inner'] === 'none' ? this.personal['fabric'] : this.personal['contrast_collar_stand_inner']) + '/mask/mask_collar_inner_stand.png';
	    },
	    collarInnerBackUrl: function collarInnerBackUrl() {
	      return window.shirtdesigner['compositeUrl'] + '/cps/collarstand/texture/' + (this.personal['contrast_collar_stand_outer'] === 'none' ? this.personal['fabric'] : this.personal['contrast_collar_stand_outer']) + '/mask/mask_collar_stand_' + this.personal['collar'] + '.png';
	    },
	    bagsUrl: function bagsUrl() {
	      return window.shirtdesigner['compositeUrl'] + '/cps/bags/texture/' + this.personal['fabric'] + '/mask/bags_' + this.personal['bags'] + '_' + this.personal['bagsposition'] + '.png';
	    }
	  },
	  methods: {
	    touchhover: function touchhover(event) {
	      jQuery('#' + event.currentTarget.id).addClass('hover_effect');
	    },
	    touchhoverout: function touchhoverout(event) {
	      jQuery('#' + event.currentTarget.id).delay(300).removeClass('hover_effect');
	    },
	    nextStep: function nextStep() {
	      if (this.count++ >= this.views.length - 1) {
	        this.count = 0;
	      }
	      var contents = this.views[this.count];
	      var selectBox = this.selectBoxes[contents];
	      if (this.count >= 1) {
	        this.updateSteps(this.count - 1);
	      }
	      if (!selectBox.active) {
	        this.updateSteps(this.count);
	        this.addStep(this.count);
	        this.nextStep();
	      }
	      this.setView(this.count);
	      this.loadContents(this.count);
	      this.addStep(this.count);
	      this.setMobileTitle();
	      this.scrollStepsOnMobile(this.count);
	    },
	    prevStep: function prevStep() {
	      if (this.count > 0) {
	        this.count--;
	      }
	      if (this.count >= -1) {
	        this.updateSteps(this.count + 1);
	      }
	      if (this.count > 0) {
	        var contents = this.views[this.count];
	        var selectBox = this.selectBoxes[contents];
	        if (!selectBox.active) {
	          this.updateSteps(this.count);
	          if (this.count > 0) {
	            this.prevStep();
	          }
	        }
	      }
	      this.setView(this.count);
	      this.loadContents(this.count);
	      this.addStep(this.count);
	      this.setMobileTitle();
	      this.scrollStepsOnMobile(this.count);
	    },
	    addStep: function addStep(c) {
	      if (this.steps.length <= c && c < 26 && this.selectBoxes[this.views[c]].title !== '') {
	        this.steps.push(this.selectBoxes[this.views[c]].title);
	        this.runDesignJQuery();
	      }
	    },
	    updateSteps: function updateSteps(c) {
	      if (c >= 0 && c <= 26) {
	        var stepTitle;
	
	        if (c === 0 || this.views[c] === 'fabric') {
	          stepTitle = window.shirtdesigner.translations['Fabric'];
	        } else {
	          stepTitle = this.selectBoxes[this.views[c]].title.trim();
	        }
	        switch (c) {
	          case 0:
	          case 15:
	          case 16:
	          case 17:
	          case 18:
	          case 19:
	          case 20:
	          case 21:
	          case 22:
	          case 23:
	          case 24:
	          case 25:
	            jQuery.getJSON(window.shirtdesigner['baseurl'] + 'designer/ajax/getFabricBySku', { sku: this.personal[this.views[c]], type: 'shirt' }).done(function (data) {
	              this.stepValue[c] = data.title;
	              if (c === 0) {
	                window.shirtdesigner.extraPrices['fabric'] = data.price;
	                this.updatePrice();
	              }
	              if (this.stepValue[c]) {
	                stepTitle = stepTitle.trim() + ': ' + this.stepValue[c];
	              } else {
	                stepTitle = stepTitle.trim();
	              }
	              if (stepTitle !== '' && c !== 26 && c !== 14) {
	                this.steps[c] = stepTitle;
	                this.steps.push('x');
	                this.steps.pop();
	              }
	            }.bind(this));
	            break;
	          case 6:
	            jQuery.getJSON(window.shirtdesigner['baseurl'] + 'designer/ajax/getButtonBySku', { sku: this.personal[this.views[c]] }).done(function (data) {
	              this.stepValue[c] = data.title;
	              if (this.stepValue[c]) {
	                stepTitle = stepTitle.trim() + ': ' + this.stepValue[c];
	              } else {
	                stepTitle = stepTitle.trim();
	              }
	              if (stepTitle !== '' && c !== 26) {
	                this.steps[c] = stepTitle;
	                this.steps.push('x');
	                this.steps.pop();
	              }
	            }.bind(this));
	            break;
	          case 12:
	          case 13:
	            jQuery.getJSON(window.shirtdesigner['baseurl'] + 'designer/ajax/getYarnBySku', { sku: this.personal[this.views[c]] }).done(function (data) {
	              this.stepValue[c] = data.title;
	              if (this.stepValue[c]) {
	                stepTitle = stepTitle.trim() + ': ' + this.stepValue[c];
	              } else {
	                stepTitle = stepTitle.trim();
	              }
	              if (stepTitle !== '' && c !== 26) {
	                this.steps[c] = stepTitle;
	                this.steps.push('x');
	                this.steps.pop();
	              }
	            }.bind(this));
	            break;
	          default:
	            this.stepValue[c] = this.personal[this.views[c]];
	            if (this.stepValue[c] in window.shirtdesigner.translations) {
	              this.stepValue[c] = window.shirtdesigner.translations[this.stepValue[c]].trim();
	            }
	            if ((c === 10 || c === 11) && this.stepValue[c] === 'keine') {
	              this.stepValue[c] = 'keines';
	            }
	            var contents = this.views[c];
	            var selectBox = this.selectBoxes[contents];
	            if (c === 0 || c === '0') {
	              selectBox = { 'component': 'fabric', 'title': window.shirtdesigner.translations['Fabric'], 'todo': window.shirtdesigner.translations['Choose from these fabrics.'], 'active': true };
	            }
	            if (this.stepValue[c] && selectBox.active) {
	              stepTitle = stepTitle.trim() + ': ' + this.stepValue[c];
	            } else {
	              stepTitle = stepTitle.trim();
	            }
	            if (stepTitle !== '' && c !== 26) {
	              this.steps[c] = stepTitle;
	              this.steps.push('x');
	              this.steps.pop();
	              this.runDesignJQuery();
	            }
	        }
	      }
	    },
	    gotoStep: function gotoStep(c) {
	      for (var i = 0; i <= c; i++) {
	        this.updateSteps(i);
	      }
	      var contents = this.views[c];
	      var selectBox = this.selectBoxes[contents];
	      if (typeof selectBox !== 'undefined') {
	        if (selectBox.active) {
	          this.updateSteps(this.count);
	          this.setView(c);
	          this.count = c;
	          if (c > 0) {
	            this.loadContents(c);
	          }
	          this.setMobileTitle();
	        }
	      } else {
	        this.updateSteps(this.count);
	        this.setView(c);
	        this.count = c;
	        if (c > 0) {
	          this.loadContents(c);
	        }
	        this.setMobileTitle();
	      }
	      this.scrollStepsOnMobile(c);
	    },
	    setMobileTitle: function setMobileTitle() {
	      if (this.selectBoxes[this.views[this.count]]) {
	        this.currentStep = this.selectBoxes[this.views[this.count]].title;
	      } else {
	        this.currentStep = window.shirtdesigner.translations['Fabric'];
	      }
	      if (this.currentExtraPrices[this.views[this.count]] && Number(this.currentExtraPrices[this.views[this.count]]) > 0) {
	        this.currentPrice = Number(this.currentExtraPrices[this.views[this.count]]).toFixed(2);
	      } else {
	        this.currentPrice = '';
	      }
	    },
	    setView: function setView(c) {
	      var contents = this.views[c];
	      localStorage.setItem('currentViewShirt', c);
	      var oldView = this.currentView;
	      switch (contents) {
	        case 'fabric':
	          this.currentView = 'fabric';
	          break;
	        case 'buttons':
	          this.currentView = 'buttons';
	          break;
	        case 'collar':
	          this.currentView = 'collar';
	          break;
	        case 'cuff':
	          this.currentView = 'cuff';
	          break;
	        case 'bags':
	          this.currentView = 'bags';
	          break;
	        case 'monogramm':
	          this.currentView = 'monogramm';
	          break;
	        case 'hankerchief':
	          this.currentView = 'hankerchief';
	          break;
	        case 'yarncontrast':
	        case 'yarnbuttonhole':
	          this.currentView = 'yarnbuttonhole';
	          break;
	        case 'contrastjumper':
	          this.currentView = 'contrastjumper';
	          break;
	        case 'contrast_collar_outside':
	        case 'contrast_collar_bottom':
	        case 'contrast_collar_stand_outer':
	        case 'contrast_collar_stand_inner':
	        case 'contrast_cuff_outside':
	        case 'contrast_cuff_inside':
	        case 'contrast_sleeve_buttons_outside':
	        case 'contrast_sleeve_buttons_inside':
	        case 'contrast_bs_upper_outside':
	        case 'contrast_bs_upper_inside':
	        case 'contrast_bs_bottom_outside':
	          this.currentView = 'ContrastCollarOutside';
	          break;
	        case 'checkout':
	          this.currentView = 'checkout';
	          break;
	        default:
	          this.currentView = 'fit';
	          break;
	      }
	      this.isActive = this.personal[contents];
	      if (this.currentView === oldView) {
	        this.currentView = '';
	        this.$nextTick(function () {
	          this.currentView = oldView;
	        });
	      }
	    },
	    getPersonalData: function getPersonalData() {
	      var result = {};
	      var data = this.personal;
	      if (data !== undefined) {
	        var keys = (0, _keys2.default)(data);
	        var i = 0;
	        var key;
	        while (keys[i]) {
	          key = keys[i];
	          if (key === 'topseller') {
	            result[key] = '';
	          } else {
	            result[key] = localStorage.getItem(key) ? JSON.parse(localStorage[key]) : data[key];
	          }
	          this.implementDependencies(key, result[key]);
	          i++;
	        }
	      }
	      return result;
	    },
	    resetConfig: function resetConfig() {
	      var data = this.personal;
	      var keys = (0, _keys2.default)(data);
	      var key;
	      var i = 0;
	      window.shirtdesigner.swal({
	        title: window.shirtdesigner.translations['Are you sure?'],
	        text: window.shirtdesigner.translations['Your current design will be reseted.'],
	        type: 'warning',
	        showCancelButton: true,
	        confirmButtonColor: '#0092a9',
	        cancelButtonText: window.shirtdesigner.translations['Cancel'],
	        confirmButtonText: window.shirtdesigner.translations['Yes, reset it!'],
	        closeOnConfirm: true
	      }, function (isConfirm) {
	        if (isConfirm) {
	          while (keys[i]) {
	            key = keys[i];
	            this.personal[key] = this.defaults[key];
	            if (localStorage.getItem(key)) {
	              localStorage.removeItem(key);
	            }
	            i++;
	          }
	          localStorage.setItem('currentViewShirt', 0);
	          this.count = 0;
	          this.gotoStep(0);
	          jQuery.post(this.baseurl + 'designer/ajax/reset', { type: 'shirt' });
	
	          this.designName = 'Mein Design';
	          this.steps = [window.shirtdesigner.translations['Fabric']];
	          this.updatePrice();
	        }
	      }.bind(this));
	    },
	    addToCart: function addToCart() {
	      var addToCartURL = window.shirtdesigner['baseurl'] + 'designer/ajax/addToCart';
	      var serialized = {
	        shirt: this.getPersonalData(),
	        measurement: { entity: jQuery('#shirtdesigner-measurement-select').val() }
	      };
	      jQuery.post(addToCartURL, serialized, function (data) {
	        this.selectItems = JSON.parse(data);
	        this.addToCartText = this.selectItems.checkoutText;
	      }.bind(this));
	    },
	    showSummary: function showSummary() {
	      this.showModal = true;
	    },
	    loadContents: function loadContents(c) {
	      var contents = this.views[c];
	      this.selectBox = this.selectBoxes[contents];
	      this.selectItems = [];
	      switch (contents) {
	        case 'buttons':
	          jQuery.getJSON(window.shirtdesigner['baseurl'] + '/designer/ajax/getButtonBySku', { sku: this.personal['buttons'] }, function (data) {
	            var currentButton = data;
	            this.buttonsection = currentButton.section;
	            jQuery.getJSON(window.shirtdesigner['baseurl'] + '/designer/ajax/getButtonList', { target: 'button', type: 'shirt', section: currentButton.section }, function (finalData) {
	              if (c === this.count) {
	                this.selectItems = finalData;
	              }
	            }.bind(this));
	          }.bind(this));
	          break;
	        case 'monogramm':
	        case 'yarncontrast':
	        case 'yarnbuttonhole':
	          jQuery.getJSON(window.shirtdesigner['baseurl'] + '/designer/ajax/getYarnList', { type: 'all' }, function (data) {
	            data.unshift({ 'entity_id': '0', 'ref_number': 'none', 'name': 'Neutral', 'infotext': 'neutral', 'quality': 'classic', 'thumb': 'upload/image/dummy_product_small.jpg', 'color_code': 'neutral', 'pattern': '', 'weave': '', 'composition': '', 'season': '', 'occasion': '', 'yarn': '', 'weight': '', 'new': '0', 'topseller': '0', 'retail_title': '', 'retail_id': '', 'price': '0', 'special_price': '0' });
	            this.fabrics = data;
	          }.bind(this));
	          break;
	        case 'contrast_collar_outside':
	        case 'contrast_collar_bottom':
	        case 'contrast_collar_stand_outer':
	        case 'contrast_collar_stand_inner':
	        case 'contrast_cuff_outside':
	        case 'contrast_cuff_inside':
	        case 'contrast_sleeve_buttons_inside':
	        case 'contrast_sleeve_buttons_outside':
	        case 'contrast_bs_upper_outside':
	        case 'contrast_bs_upper_inside':
	        case 'contrast_bs_bottom_outside':
	          jQuery.getJSON(window.shirtdesigner['baseurl'] + '/designer/ajax/getFabricList', { type: 'shirt', basefabricsku: this.personal['fabric'] }, function (data) {
	            data.unshift({ 'entity_id': '0', 'ref_number': 'none', 'name': 'Neutral', 'infotext': 'neutral', 'quality': 'classic', 'thumb': 'upload/image/dummy_product_small.jpg', 'color': 'neutral', 'material': '', 'pattern': '', 'weave': '', 'composition': '', 'season': '', 'occasion': '', 'yarn': '', 'weight': '', 'new': '0', 'topseller': '0', 'retail_title': '', 'retail_id': '', 'price': '49.90', 'special_price': '0' });
	            this.fabrics = data;
	          }.bind(this));
	          break;
	        case 'fabric':
	          this.selectItems = [];
	          break;
	        default:
	          this.selectItems = this.selectBoxItems[contents];
	      }
	      this.isActive = this.personal[contents];
	    },
	    loadDesignData: function loadDesignData(data) {
	      if (data !== undefined && data.name !== null) {
	        this.designName = data.name ? data.name : 'Mein Design';
	        var keys = (0, _keys2.default)(this.personal);
	        var i = 0;
	        var key;
	        while (keys[i]) {
	          key = keys[i];
	          this.personal[key] = data[key] ? data[key] : this.defaults[key];
	          this.updateSteps(i);
	          i++;
	        }
	        this.updatePrice();
	        this.runDesignJQuery();
	      }
	    },
	    updatePrice: function updatePrice() {
	      this.price = window.shirtdesigner.extraPrices['fabric'] > 0 ? window.shirtdesigner.extraPrices['fabric'] : window.shirtdesigner['priceClassic'];
	      this.price = Number(this.price).toFixed(2);
	
	      var buttonSku = this.personal['buttons'];
	      var updateButtonPrice = jQuery.grep(this.buttons, function (e) {
	        return e.sku === buttonSku;
	      })[0];
	
	      if (typeof updateButtonPrice !== 'undefined') {
	        this.price = (Number(this.price) + Number(updateButtonPrice.price)).toFixed(2);
	        this.currentExtraPrices['buttons'] = Number(updateButtonPrice.price);
	      } else {
	        this.currentExtraPrices['buttons'] = 0;
	      }
	
	      if (this.personal['monogramm'] !== 'no_monogramm' && this.personal['monogramm'].length > 0) {
	        this.price = (Number(this.price) + Number(window.shirtdesigner.extraPrices['monogramm'])).toFixed(2);
	        this.currentExtraPrices['monogramm'] = Number(window.shirtdesigner.extraPrices['monogramm']);
	      } else {
	        this.currentExtraPrices['monogramm'] = 0;
	      }
	
	      if (this.personal['yarncontrast'] !== 'neutral' && this.personal['yarncontrast'] !== '') {
	        this.price = (Number(this.price) + Number(window.shirtdesigner.extraPrices['yarncontrast'])).toFixed(2);
	        this.currentExtraPrices['yarncontrast'] = Number(window.shirtdesigner.extraPrices['yarncontrast']);
	      } else {
	        this.currentExtraPrices['yarncontrast'] = 0;
	      }
	
	      if (this.personal['yarnbuttonhole'] !== 'neutral' && this.personal['yarnbuttonhole'] !== '') {
	        this.price = (Number(this.price) + Number(window.shirtdesigner.extraPrices['yarnbuttonhole'])).toFixed(2);
	        this.currentExtraPrices['yarnbuttonhole'] = Number(window.shirtdesigner.extraPrices['yarnbuttonhole']);
	      } else {
	        this.currentExtraPrices['yarnbuttonhole'] = 0;
	      }
	
	      var extras = ['contrast_cuff_outside', 'contrast_cuff_inside', 'contrast_collar_outside', 'contrast_collar_bottom', 'contrast_collar_stand_outer', 'contrast_collar_stand_inner', 'contrast_sleeve_buttons_outside', 'contrast_sleeve_buttons_inside', 'contrast_bs_upper_outside', 'contrast_bs_upper_inside', 'contrast_bs_bottom_outside'];
	      for (var i = 0; i < extras.length; i++) {
	        var s = extras[i];
	        if (this.personal[s] !== 'none' && this.personal[s] !== this.personal['fabric']) {
	          this.price = (Number(this.price) + Number(window.shirtdesigner.extraPrices[s])).toFixed(2);
	          this.currentExtraPrices[s] = Number(window.shirtdesigner.extraPrices[s]);
	        } else {
	          this.currentExtraPrices[s] = 0;
	        }
	      }
	      if (this.personal['contrast_collar_outside'] !== 'none' && this.personal['contrast_collar_outside'] !== this.personal['fabric'] && this.personal['contrast_collar_outside'] === this.personal['contrast_collar_bottom'] && this.personal['contrast_collar_outside'] === this.personal['contrast_collar_stand_outer'] && this.personal['contrast_collar_outside'] === this.personal['contrast_collar_stand_inner']) {
	        this.price = (Number(this.price) - 5).toFixed(2);
	      }
	      if (this.personal['contrast_cuff_outside'] !== 'none' && this.personal['contrast_cuff_outside'] !== this.personal['fabric'] && this.personal['contrast_cuff_outside'] === this.personal['contrast_cuff_inside'] && this.personal['contrast_cuff_outside'] === this.personal['contrast_sleeve_buttons_outside'] && this.personal['contrast_cuff_outside'] === this.personal['contrast_sleeve_buttons_inside']) {
	        this.price = (Number(this.price) - 5).toFixed(2);
	      }
	      if (this.personal['hankerchief'] === 'yes') {
	        this.price = (Number(this.price) + Number(window.shirtdesigner.extraPrices['hankerchief'])).toFixed(2);
	        this.currentExtraPrices['hankerchief'] = Number(window.shirtdesigner.extraPrices['hankerchief']);
	      } else {
	        this.currentExtraPrices['hankerchief'] = 0;
	      }
	      if (this.personal['outsize'] !== 'none') {
	        this.price = (Number(this.price) + Number(this.priceExtra)).toFixed(2);
	      }
	    },
	    saveDesign: function saveDesign(event) {
	      var saveDesignURL = this.baseurl + 'designer/ajax/saveDesign';
	      if (this.personal) {
	        var serialized = { type: 'shirt', name: this.designName, shirt: this.personal };
	        jQuery.post(saveDesignURL, serialized, function (data) {
	          var applyMsg = JSON.parse(data);
	          this.msg = applyMsg;
	          jQuery('#messages').fadeIn('slow').delay(4000).fadeOut('slow');
	        }.bind(this));
	      }
	    },
	    clearViewCount: function clearViewCount() {
	      if (localStorage.getItem('currentViewShirt')) {
	        localStorage.removeItem('currentViewShirt');
	      }
	      var data = this.personal;
	      var keys = (0, _keys2.default)(data);
	      var key;
	      var i = 0;
	      while (keys[i]) {
	        key = keys[i];
	        this.personal[key] = this.defaults[key];
	        if (localStorage.getItem(key)) {
	          localStorage.removeItem(key);
	        }
	        i++;
	      }
	      jQuery('#product_addtocart_form').submit();
	    },
	    setSelectStatus: function setSelectStatus(component, value) {
	      if (component !== undefined) {
	        this.selectBoxes[component].active = value;
	        if (value === false) {
	          this.personal[component] = this.defaults[component];
	        }
	        this.updatePrice();
	      }
	    },
	    implementDependencies: function implementDependencies(component, value) {
	      switch (component) {
	        case 'sleeve':
	          if (value === 'short' || value === 'shortbar') {
	            this.sleevesShort = true;
	            this.setSelectStatus('cuff', false);
	            this.setSelectStatus('contrast_cuff_outside', false);
	            this.setSelectStatus('contrast_cuff_inside', false);
	            this.setSelectStatus('contrast_sleeve_buttons_outside', false);
	            this.setSelectStatus('contrast_sleeve_buttons_inside', false);
	          } else {
	            this.sleevesShort = false;
	            this.setSelectStatus('cuff', true);
	            this.setSelectStatus('contrast_cuff_outside', true);
	            this.setSelectStatus('contrast_cuff_inside', true);
	            this.setSelectStatus('contrast_sleeve_buttons_outside', true);
	            this.setSelectStatus('contrast_sleeve_buttons_inside', true);
	          }
	          break;
	
	        case 'cuff':
	          if (value === 'roundenv' || this.sleevesShort) {
	            this.setSelectStatus('contrast_cuff_inside', false);
	          } else {
	            this.setSelectStatus('contrast_cuff_inside', true);
	          }
	          break;
	        case 'collar':
	          if (value === 'standup') {
	            this.setSelectStatus('contrast_collar_outside', false);
	            this.setSelectStatus('contrast_collar_bottom', false);
	          } else {
	            this.setSelectStatus('contrast_collar_outside', true);
	            this.setSelectStatus('contrast_collar_bottom', true);
	          }
	          break;
	      }
	    },
	    updateMonogrammPosition: function updateMonogrammPosition(pos) {
	      jQuery(document).ready(function () {
	        switch (pos) {
	          case 'waistleft':
	            jQuery('.img-monogramm').css('top', '280px');
	            jQuery('.img-monogramm').css('left', '195px');
	            break;
	          case 'waistright':
	            jQuery('.img-monogramm').css('top', '280px');
	            jQuery('.img-monogramm').css('left', '85px');
	            break;
	          case 'cuffleft':
	            jQuery('.img-monogramm').css('top', '305px');
	            jQuery('.img-monogramm').css('left', '255px');
	            break;
	          case 'cuffright':
	            jQuery('.img-monogramm').css('top', '298px');
	            jQuery('.img-monogramm').css('left', '35px');
	            break;
	          case 'collarleft':
	            jQuery('.img-monogramm').css('top', '32px');
	            jQuery('.img-monogramm').css('left', '165px');
	            break;
	          case 'collarright':
	            jQuery('.img-monogramm').css('top', '32px');
	            jQuery('.img-monogramm').css('left', '115px');
	            break;
	          case 'pocketleft':
	            jQuery('.img-monogramm').css('top', '170px');
	            jQuery('.img-monogramm').css('left', '195px');
	            break;
	          case 'pocketright':
	            jQuery('.img-monogramm').css('top', '170px');
	            jQuery('.img-monogramm').css('left', '85px');
	            break;
	        }
	      });
	    },
	    runDesignJQuery: function runDesignJQuery() {
	      if (jQuery(window).width() > 767) {
	        jQuery('.preview-col, .select-col, .infobox').css('height', 'auto');
	        if (jQuery('.select-col').outerHeight() > jQuery('.infobox').outerHeight()) {
	          jQuery('.preview-col, #konfigurator .select-col, .infobox').css('height', jQuery('.select-col').outerHeight() + jQuery('.top-step-name').outerHeight() + 30);
	        } else {
	          jQuery('.preview-col, #konfigurator .select-col, .infobox').css('height', jQuery('.infobox').outerHeight() + jQuery('.top-step-name').outerHeight() + 30);
	        }
	      }
	    },
	    scrollStepsOnMobile: function scrollStepsOnMobile(number) {
	      if (jQuery(window).width() < 768) {
	        jQuery('html, body').animate({ scrollTop: 150 }, 'slow');
	      }
	      if (jQuery(window).width() < 768 && jQuery('#' + number).length > 0) {
	        jQuery('.step').animate({
	          scrollLeft: jQuery('.step').scrollLeft() + jQuery('#' + number).position().left
	        }, 200);
	      }
	    }
	  },
	  events: {
	    getFabricData: function getFabricData(event) {
	      var selectorId = event.currentTarget.id;
	      window.shirtdesigner.extraPrices['fabric'] = event.currentTarget.dataset.price;
	      if (selectorId !== '') {
	        jQuery.getJSON(window.shirtdesigner['baseurl'] + 'designer/ajax/getList', { target: 'fabric', qlty: selectorId, type: 'shirt' }, function (data) {
	          this.fabrics = data;
	        }.bind(this));
	      }
	    },
	    updatePersonalData: function updatePersonalData(data) {
	      if (data[0].length && data[1] !== undefined) {
	        localStorage.setItem(data[0], (0, _stringify2.default)(data[1]));
	        this.personal[data[0]] = data[1];
	        this.implementDependencies(data[0], data[1]);
	        this.updatePrice();
	        this.setMobileTitle();
	        this.updateSteps(this.count);
	      }
	    },
	    runDesignJQuery: function runDesignJQuery() {
	      this.runDesignJQuery();
	    },
	    setMsg: function setMsg(msg) {
	      this.flash = msg;
	      jQuery('#flash').fadeIn('slow').delay(4000).fadeOut('slow');
	    },
	    updateMonoPosition: function updateMonoPosition(pos) {
	      this.updateMonogrammPosition(pos);
	    },
	    jumpTo: function jumpTo(page) {
	      if (page === 'last') {
	        this.gotoStep(this.views.length - 1);
	      } else if (page === 'contrast') {
	        this.gotoStep(15);
	      }
	    },
	    setSwatch: function setSwatch(object) {
	      this[object.key] = object.value;
	    },
	    mainCheckDesign: function mainCheckDesign() {
	      var $this = this;
	      setTimeout(function () {
	        $this.runDesignJQuery();
	      }, 500);
	    }
	  },
	  watch: {
	    steps: function steps() {
	      this.runDesignJQuery();
	    }
	  },
	  ready: function ready() {
	    this.runDesignJQuery();
	  }
	};

/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Zoom = __webpack_require__(1);
	
	var _Zoom2 = _interopRequireDefault(_Zoom);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'Bags',
	  data: function data() {
	    return {
	      selected: typeof this.personal['bagsposition'] !== 'undefined' ? this.personal['bagsposition'] : '',
	      globals: window.shirtdesigner,
	      show: {
	        type: Boolean,
	        required: true,
	        twoWay: true
	      }
	    };
	  },
	  props: ['fabrics', 'items', 'box', 'filtertext', 'zoom', 'show', 'baseurl', 'personal', 'isactive'],
	  components: {
	    Zoom: _Zoom2.default
	  },
	  methods: {
	    updatePersonal: function updatePersonal(event) {
	      this.$dispatch('updatePersonalData', [event.currentTarget.dataset.component, event.currentTarget.id]);
	      this.isactive = event.currentTarget.id;
	      if (event.currentTarget.id === 'none') {
	        this.$dispatch('updatePersonalData', ['bagsposition', '']);
	      } else if (this.personal['bagsposition'] === '') {
	        this.$dispatch('updatePersonalData', ['bagsposition', 'left']);
	      }
	      if (event.currentTarget.id === 'none' && (this.personal['monopos'] === 'pocketleft' || this.personal['monopos'] === 'pocketright')) {
	        this.$dispatch('updatePersonalData', ['monogramm', '']);
	        this.$dispatch('updatePersonalData', ['monopos', 'waistleft']);
	      }
	    },
	    updatePersonalBags: function updatePersonalBags(event) {
	      this.$dispatch('updatePersonalData', [event.currentTarget.id, this.selected]);
	      if (this.selected === 'left' && this.personal['monopos'] === 'pocketright') {
	        this.$dispatch('updatePersonalData', ['monogramm', '']);
	        this.$dispatch('updatePersonalData', ['monopos', 'waistleft']);
	      } else if (this.selected === 'right' && this.personal['monopos'] === 'pocketleft') {
	        this.$dispatch('updatePersonalData', ['monogramm', '']);
	        this.$dispatch('updatePersonalData', ['monopos', 'waistleft']);
	      }
	    },
	    zoomFabric: function zoomFabric(event) {
	      this.zoom = {
	        img: this.baseurl + 'media/jack/shirt/zoom/' + this.box.component + '_' + event.currentTarget.dataset.refnr + '.jpg',
	        title: event.currentTarget.dataset.title,
	        infotext: event.currentTarget.dataset.infotext,
	        weight: event.currentTarget.dataset.weight,
	        composition: event.currentTarget.dataset.composition,
	        weave: event.currentTarget.dataset.weave,
	        yarn: event.currentTarget.dataset.yarn,
	        refnr: event.currentTarget.dataset.refnr,
	        price: Number(event.currentTarget.dataset.price).toFixed(2)
	      };
	      this.show = true;
	    }
	  },
	  ready: function ready() {
	    this.$dispatch('runDesignJQuery');
	  }
	};

/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Zoom = __webpack_require__(1);
	
	var _Zoom2 = _interopRequireDefault(_Zoom);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var jQuery = __webpack_require__(4);
	
	exports.default = {
	  name: 'Buttons',
	  data: function data() {
	    return {
	      section: this.section,
	      globals: window.shirtdesigner,
	      show: {
	        type: Boolean,
	        required: true,
	        twoWay: true
	      },
	      translations: window.shirtdesigner.translations,
	      selectedScrollHeight: document.getElementById(this.box.component) ? document.getElementById(this.box.component).scrollHeight : 0,
	      selectedClientHeight: document.getElementById(this.box.component) ? document.getElementById(this.box.component).clientHeight : 0,
	      scrollPosition: 0,
	      scrolling: false,
	      touchstart: false
	    };
	  },
	  props: ['fabrics', 'items', 'box', 'filtertext', 'zoom', 'show', 'baseurl', 'personal', 'isactive', 'section', 'buttonsection'],
	  components: {
	    Zoom: _Zoom2.default
	  },
	  methods: {
	    updatePersonal: function updatePersonal(event) {
	      this.$dispatch('updatePersonalData', [event.currentTarget.dataset.component, event.currentTarget.id]);
	      if (event.currentTarget.dataset.btncolor) {
	        this.$dispatch('updatePersonalData', ['button-color', event.currentTarget.dataset.btncolor]);
	      }
	      if (event.currentTarget.dataset.price !== 'undefined' && event.currentTarget.dataset.price !== '') {
	        this.box.extra = Number(event.currentTarget.dataset.price).toFixed(2);
	      } else {
	        this.box.extra = '0,00';
	      }
	      this.isactive = event.currentTarget.id;
	    },
	    scrolldown: function scrolldown() {
	      if (this.touchstart === false) {
	        var ele = document.getElementById(this.box.component);
	        var speed = 25;
	        var scroll = 5;
	        var $this = this;
	        this.scrolling = window.setInterval(function () {
	          ele.scrollTop = ele.scrollTop + scroll;
	          $this.itemsScroll();
	        }, speed);
	      }
	    },
	    scrollup: function scrollup() {
	      if (this.touchstart === false) {
	        var ele = document.getElementById(this.box.component);
	        var speed = 25;
	        var scroll = 5;
	        var $this = this;
	        this.scrolling = window.setInterval(function () {
	          ele.scrollTop = ele.scrollTop - scroll;
	          $this.itemsScroll();
	        }, speed);
	      }
	    },
	    mouseleave: function mouseleave() {
	      if (this.scrolling) {
	        window.clearInterval(this.scrolling);
	        this.scrolling = false;
	      }
	    },
	    touchstartup: function touchstartup() {
	      this.touchstart = true;
	      var ele = document.getElementById(this.box.component);
	      var speed = 25;
	      var scroll = 5;
	      var $this = this;
	      this.scrolling = window.setInterval(function () {
	        ele.scrollTop = ele.scrollTop - scroll;
	        $this.itemsScroll();
	      }, speed);
	    },
	    touchstartdown: function touchstartdown() {
	      this.touchstart = true;
	      var ele = document.getElementById(this.box.component);
	      var speed = 25;
	      var scroll = 5;
	      var $this = this;
	      this.scrolling = window.setInterval(function () {
	        ele.scrollTop = ele.scrollTop + scroll;
	        $this.itemsScroll();
	      }, speed);
	    },
	    touchend: function touchend() {
	      this.mouseleave();
	    },
	    setFilter: function setFilter(event) {
	      var number = event.currentTarget.id.split('_');
	      this.section = number[2];
	      jQuery.getJSON(window.shirtdesigner['baseurl'] + '/designer/ajax/getButtonList', { type: 'shirt', section: this.section }, function (data) {
	        this.items = data;
	      }.bind(this));
	    },
	    resetFilter: function resetFilter(event) {
	      this.section = null;
	      jQuery.getJSON(window.shirtdesigner['baseurl'] + '/designer/ajax/getButtonList', { type: 'shirt', section: this.section }, function (data) {
	        this.items = data;
	      }.bind(this));
	    },
	    zoomFabric: function zoomFabric(event) {
	      this.zoom = {
	        img: this.baseurl + 'media/jack/buttons/zoom/' + this.box.component + '_' + event.currentTarget.dataset.refnr + '.jpg',
	        title: event.currentTarget.dataset.title,
	        infotext: event.currentTarget.dataset.infotext,
	        weight: event.currentTarget.dataset.weight,
	        composition: event.currentTarget.dataset.composition,
	        weave: event.currentTarget.dataset.weave,
	        yarn: event.currentTarget.dataset.yarn,
	        refnr: event.currentTarget.dataset.refnr,
	        price: Number(event.currentTarget.dataset.price).toFixed(2)
	      };
	      this.show = true;
	    },
	    checkMeasures: function checkMeasures() {
	      this.selectedScrollHeight = document.getElementById(this.box.component) ? document.getElementById(this.box.component).scrollHeight : 0;
	      this.selectedClientHeight = document.getElementById(this.box.component) ? document.getElementById(this.box.component).clientHeight : 0;
	    },
	    itemsScroll: function itemsScroll() {
	      var ele = document.getElementById(this.box.component);
	      this.scrollPosition = ele.scrollTop;
	      this.checkMeasures();
	    }
	  },
	  watch: {
	    items: function items() {
	      this.checkMeasures();
	    },
	    filtertext: function filtertext() {
	      this.checkMeasures();
	    },
	    buttonsection: function buttonsection() {
	      this.section = this.buttonsection;
	    }
	  },
	  ready: function ready() {
	    this.checkMeasures();
	    this.$dispatch('runDesignJQuery');
	  },
	  created: function created() {
	    this.section = this.buttonsection;
	  }
	};

/***/ }),
/* 18 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  name: 'Checkout',
	  props: { 'fabrics': '', 'items': '', 'box': '', modalcontent: [],
	    show: {
	      type: Boolean,
	      required: true,
	      twoWay: true
	    }
	  },
	  data: function data() {
	    return {
	      globals: window.shirtdesigner
	    };
	  },
	  ready: function ready() {
	    this.$dispatch('runDesignJQuery');
	  }
	};

/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Zoom = __webpack_require__(1);
	
	var _Zoom2 = _interopRequireDefault(_Zoom);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'Cuff',
	  data: function data() {
	    return {
	      selected: typeof this.personal['collarbuttons'] !== 'undefined' ? this.personal['collarbuttons'] : '',
	      selected_strength: typeof this.personal['collar_strength'] !== 'undefined' ? this.personal['collar_strength'] : '',
	      selected_height: typeof this.personal['collar_height'] !== 'undefined' ? this.personal['collar_height'] : '',
	      globals: window.shirtdesigner,
	      show: {
	        type: Boolean,
	        required: true,
	        twoWay: true
	      },
	      personal: this.personal
	    };
	  },
	  props: ['fabrics', 'items', 'box', 'filtertext', 'baseurl', 'personal', 'isactive', 'zoom', 'show', 'translations'],
	  components: {
	    Zoom: _Zoom2.default
	  },
	  methods: {
	    updatePersonal: function updatePersonal(event) {
	      this.$dispatch('updatePersonalData', [event.currentTarget.dataset.component, event.currentTarget.id]);
	      this.isactive = event.currentTarget.id;
	    },
	    updatePersonalCollar: function updatePersonalCollar(event) {
	      this.$dispatch('updatePersonalData', [event.currentTarget.id, this.selected]);
	    },
	    updatePersonalCollarHeight: function updatePersonalCollarHeight(event) {
	      this.$dispatch('updatePersonalData', [event.currentTarget.id, this.selected_height]);
	    },
	    updatePersonalCollarStrength: function updatePersonalCollarStrength(event) {
	      this.$dispatch('updatePersonalData', [event.currentTarget.id, this.selected_strength]);
	    },
	    zoomFabric: function zoomFabric(event) {
	      this.zoom = {
	        img: this.baseurl + 'media/jack/shirt/zoom/' + this.box.component + '_' + event.currentTarget.dataset.refnr + '.jpg',
	        title: event.currentTarget.dataset.title,
	        infotext: event.currentTarget.dataset.infotext,
	        weight: event.currentTarget.dataset.weight,
	        composition: event.currentTarget.dataset.composition,
	        weave: event.currentTarget.dataset.weave,
	        yarn: event.currentTarget.dataset.yarn,
	        refnr: event.currentTarget.dataset.refnr,
	        price: Number(event.currentTarget.dataset.price).toFixed(2)
	      };
	      this.show = true;
	    },
	    checkMeasures: function checkMeasures() {
	      this.selectedScrollHeight = document.getElementById(this.box.component) ? document.getElementById(this.box.component).scrollHeight : 0;
	      this.selectedClientHeight = document.getElementById(this.box.component) ? document.getElementById(this.box.component).clientHeight : 0;
	    }
	  },
	  watch: {
	    items: function items() {
	      this.checkMeasures();
	    },
	    filtertext: function filtertext() {
	      this.checkMeasures();
	    }
	  },
	  ready: function ready() {
	    this.checkMeasures();
	    this.$dispatch('runDesignJQuery');
	  }
	};

/***/ }),
/* 20 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _stringify = __webpack_require__(2);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _Filter = __webpack_require__(14);
	
	var _Filter2 = _interopRequireDefault(_Filter);
	
	var _Fabrics = __webpack_require__(13);
	
	var _Fabrics2 = _interopRequireDefault(_Fabrics);
	
	var _Zoom = __webpack_require__(1);
	
	var _Zoom2 = _interopRequireDefault(_Zoom);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var jQuery = __webpack_require__(4);
	
	exports.default = {
	  name: 'ConstrastCollarOutside',
	  data: function data() {
	    return {
	      showPattern: false,
	      showColor: false,
	      showWeave: false,
	      showMaterial: false,
	      showOccasion: false,
	      showPrice: false,
	      showSeason: false,
	      selectPrice: '74.90',
	      filtercolor: '',
	      filterpattern: '',
	      filterweave: '',
	      filtermaterial: '',
	      filteroccasion: '',
	      filtername: '',
	      isactive: this.isactive,
	      globals: window.shirtdesigner,
	      translations: window.shirtdesigner.translations,
	      fields: ['name', 'color', 'weave', 'season', 'occasion', 'pattern'],
	      boolfilter: { 'topseller': '0', 'new': '0' },
	      range1: { value: 49, min: 49, max: 100 },
	      range2: { value: 100, min: 50, max: 100 },
	      currentData: {},
	      scrolling: false
	    };
	  },
	  components: {
	    Filter: _Filter2.default,
	    Fabrics: _Fabrics2.default,
	    Zoom: _Zoom2.default
	  },
	  props: {
	    'box': Object,
	    'baseurl': String,
	    'personal': Object,
	    'isactive': String,
	    'fabrics': Array,
	    'filtercolor': String,
	    'filterpattern': String,
	    'filterweave': String,
	    'filtermaterial': String,
	    'filteroccasion': String,
	    'filtername': String,
	    'muster1': String,
	    'muster2': String,
	    'muster3': String,
	    'muster4': String,
	    'zoom': Object,
	    show: {
	      type: Boolean,
	      required: true,
	      twoWay: true
	    }
	  },
	  events: {
	    setFilter: function setFilter(event, callback) {
	      switch (event.currentTarget.dataset.select) {
	        case 'color':
	          if (event.currentTarget.id === 'all') {
	            this.filtercolor = '';
	            this.showColor = false;
	            callback('Color');
	          } else {
	            this.filtercolor = event.currentTarget.id;
	            callback(this.filtercolor);
	          }
	          break;
	        case 'pattern':
	          if (event.currentTarget.id === 'all') {
	            this.filterpattern = '';
	            this.showPattern = false;
	            callback('Pattern');
	          } else {
	            this.filterpattern = event.currentTarget.id;
	            callback(this.filterpattern);
	          }
	          break;
	        case 'weave':
	          if (event.currentTarget.id === 'all') {
	            this.filterweave = '';
	            this.showWeave = false;
	            callback('Weave');
	          } else {
	            this.filterweave = event.currentTarget.id;
	            callback(this.filterweave);
	          }
	          break;
	        case 'material':
	          if (event.currentTarget.id === 'all') {
	            this.filtermaterial = '';
	            this.showMaterial = false;
	            callback('Material');
	          } else {
	            this.filtermaterial = event.currentTarget.id;
	            callback(this.filtermaterial);
	          }
	          break;
	        case 'occasion':
	          if (event.currentTarget.id === 'all') {
	            this.filteroccasion = '';
	            this.showOccasion = false;
	            callback('Occasion');
	          } else {
	            this.filteroccasion = event.currentTarget.id;
	            callback(this.filteroccasion);
	          }
	          break;
	        case 'name':
	          this.filtername = event.currentTarget.value;
	          callback(this.filtername);
	          break;
	      }
	    },
	    setBoolFilter: function setBoolFilter(event, callback) {
	      if (this.boolfilter[event.currentTarget.id] !== '1') {
	        this.boolfilter[event.currentTarget.id] = '1';
	        callback('1');
	      } else {
	        this.boolfilter[event.currentTarget.id] = '0';
	        callback('0');
	      }
	    },
	    resetFilter: function resetFilter() {
	      this.showPattern = false;
	      this.showColor = false;
	      this.showWeave = false;
	      this.showMaterial = false;
	      this.showOccasion = false;
	      this.showSeason = false;
	      this.showPrice = false;
	      this.showName = false;
	      this.range1.value = this.range1.min;
	      this.range2.value = this.range2.max;
	      this.resetBoolFilter();
	      this.filtercolor = '';
	      this.filterpattern = '';
	      this.filterweave = '';
	      this.filtermaterial = '';
	      this.filteroccasion = '';
	      this.filtername = '';
	    },
	    updatePersonal: function updatePersonal(event) {
	      this.$dispatch('updatePersonalData', [event.currentTarget.dataset.component, event.currentTarget.id]);
	      this.setCurrentData(event.currentTarget.id);
	      this.isactive = event.currentTarget.id;
	    },
	    checkDesign: function checkDesign(event) {
	      this.$dispatch('mainCheckDesign', event, function () {});
	    }
	  },
	  methods: {
	    selectFabric: function selectFabric(event) {
	      this.$dispatch('getFabricData', event);
	    },
	    thumbUrl: function thumbUrl(event) {
	      return this.baseurl + event.currentTarget.dataset.thumb;
	    },
	    resetBoolFilter: function resetBoolFilter() {
	      var b;
	      for (b in this.boolfilter) {
	        this.boolfilter[b] = '0';
	      }
	    },
	    setCurrentData: function setCurrentData(sku) {
	      if (sku !== 'none') {
	        this.currentData = jQuery.grep(this.fabrics, function (e) {
	          return e.ref_number === sku;
	        })[0];
	      } else {
	        var object = {};
	        object['ref_number'] = 'none';
	        this.currentData = object;
	      }
	    },
	    zoomFabric: function zoomFabric(event) {
	      this.zoom = {
	        img: this.baseurl + 'media/' + event.currentTarget.dataset.zoom,
	        title: event.currentTarget.dataset.title,
	        infotext: event.currentTarget.dataset.infotext,
	        weight: event.currentTarget.dataset.weight,
	        composition: event.currentTarget.dataset.composition,
	        weave: event.currentTarget.dataset.weave,
	        yarn: event.currentTarget.dataset.yarn,
	        refnr: event.currentTarget.dataset.refnr,
	        price: Number(event.currentTarget.dataset.price).toFixed(2)
	      };
	      this.show = true;
	    },
	    addMobileSample: function addMobileSample(event) {
	      var exists = false;
	      var message = '';
	      var free = '';
	      var keys = ['muster1', 'muster2', 'muster3', 'muster4'];
	      var i = 0;
	      var key;
	      while (keys[i]) {
	        key = keys[i];
	        if (localStorage.getItem(key)) {
	          if (event.currentTarget.dataset.refnr === JSON.parse(localStorage.getItem(key))) {
	            exists = key;
	            break;
	          }
	        } else {
	          if (!free) free = key;
	        }
	        i++;
	      }
	      if (!exists && free) {
	        localStorage.setItem(free, (0, _stringify2.default)(event.currentTarget.dataset.refnr));
	        this.$dispatch('setSwatch', { key: free, value: event.currentTarget.dataset.refnr });
	        this.$dispatch('setMsg', { success: this.translations['Added to swatch box.'] });
	      } else {
	        if (exists) {
	          localStorage.removeItem(key);
	          this.$dispatch('setSwatch', { key: key, value: '' });
	          message = this.translations['Removed from swatch box.'];
	          this.$dispatch('setMsg', { success: message });
	        } else {
	          message = this.translations['You have already four fabrics in swatch box.'];
	          this.$dispatch('setMsg', { error: message });
	        }
	      }
	    }
	  },
	  created: function created() {
	    this.setCurrentData(this.personal[this.box.component]);
	  },
	  ready: function ready() {
	    this.$dispatch('runDesignJQuery');
	  }
	};

/***/ }),
/* 21 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  name: 'Contrastjumper',
	  props: ['fabrics', 'items', 'box', 'filtertext', 'baseurl', 'personal', 'isactive', 'translations'],
	  data: function data() {
	    return {
	      scrolling: false
	    };
	  },
	  methods: {
	    yesAction: function yesAction(event) {
	      this.$dispatch('jumpTo', 'last');
	    },
	    noAction: function noAction(event) {
	      this.$dispatch('jumpTo', 'contrast');
	    }
	  },
	  ready: function ready() {
	    this.$dispatch('runDesignJQuery');
	  }
	};

/***/ }),
/* 22 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Zoom = __webpack_require__(1);
	
	var _Zoom2 = _interopRequireDefault(_Zoom);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'Cuff',
	  data: function data() {
	    return {
	      selected: typeof this.personal['cuffwidth'] !== 'undefined' ? this.personal['cuffwidth'] : '',
	      globals: window.shirtdesigner,
	      scrolling: false,
	      touchstart: false,
	      translations: window.shirtdesigner.translations,
	      scrollPosition: 0,
	      selectedScrollHeight: document.getElementById(this.box.component) ? document.getElementById(this.box.component).scrollHeight : 0,
	      selectedClientHeight: document.getElementById(this.box.component) ? document.getElementById(this.box.component).clientHeight : 0,
	      show: {
	        type: Boolean,
	        required: true,
	        twoWay: true
	      }
	    };
	  },
	  props: ['fabrics', 'items', 'box', 'filtertext', 'baseurl', 'personal', 'isactive', 'zoom', 'show'],
	  components: {
	    Zoom: _Zoom2.default
	  },
	  methods: {
	    updatePersonal: function updatePersonal(event) {
	      this.$dispatch('updatePersonalData', [event.currentTarget.dataset.component, event.currentTarget.id]);
	      this.isactive = event.currentTarget.id;
	    },
	    updatePersonalCuff: function updatePersonalCuff(event) {
	      this.$dispatch('updatePersonalData', [event.currentTarget.id, this.selected]);
	    },
	    zoomFabric: function zoomFabric(event) {
	      this.zoom = {
	        img: this.baseurl + 'media/jack/shirt/zoom/' + this.box.component + '_' + event.currentTarget.dataset.refnr + '.jpg',
	        title: event.currentTarget.dataset.title,
	        infotext: event.currentTarget.dataset.infotext,
	        weight: event.currentTarget.dataset.weight,
	        composition: event.currentTarget.dataset.composition,
	        weave: event.currentTarget.dataset.weave,
	        yarn: event.currentTarget.dataset.yarn,
	        refnr: event.currentTarget.dataset.refnr,
	        price: Number(event.currentTarget.dataset.price).toFixed(2)
	      };
	      this.show = true;
	    },
	    scrolldown: function scrolldown() {
	      if (this.touchstart === false) {
	        var ele = document.getElementById(this.box.component);
	        var speed = 25;
	        var scroll = 5;
	        var $this = this;
	        this.scrolling = window.setInterval(function () {
	          ele.scrollTop = ele.scrollTop + scroll;
	          $this.itemsScroll();
	        }, speed);
	      }
	    },
	    scrollup: function scrollup() {
	      if (this.touchstart === false) {
	        var ele = document.getElementById(this.box.component);
	        var speed = 25;
	        var scroll = 5;
	        var $this = this;
	        this.scrolling = window.setInterval(function () {
	          ele.scrollTop = ele.scrollTop - scroll;
	          $this.itemsScroll();
	        }, speed);
	      }
	    },
	    mouseleave: function mouseleave() {
	      if (this.scrolling) {
	        window.clearInterval(this.scrolling);
	        this.scrolling = false;
	      }
	    },
	    touchstartup: function touchstartup() {
	      this.touchstart = true;
	      var ele = document.getElementById(this.box.component);
	      var speed = 25;
	      var scroll = 5;
	      var $this = this;
	      this.scrolling = window.setInterval(function () {
	        ele.scrollTop = ele.scrollTop - scroll;
	        $this.itemsScroll();
	      }, speed);
	    },
	    touchstartdown: function touchstartdown() {
	      this.touchstart = true;
	      var ele = document.getElementById(this.box.component);
	      var speed = 25;
	      var scroll = 5;
	      var $this = this;
	      this.scrolling = window.setInterval(function () {
	        ele.scrollTop = ele.scrollTop + scroll;
	        $this.itemsScroll();
	      }, speed);
	    },
	    touchend: function touchend() {
	      this.mouseleave();
	    },
	    checkMeasures: function checkMeasures() {
	      this.selectedScrollHeight = document.getElementById(this.box.component) ? document.getElementById(this.box.component).scrollHeight : 0;
	      this.selectedClientHeight = document.getElementById(this.box.component) ? document.getElementById(this.box.component).clientHeight : 0;
	    },
	    itemsScroll: function itemsScroll() {
	      var ele = document.getElementById(this.box.component);
	      this.scrollPosition = ele.scrollTop;
	      this.checkMeasures();
	    }
	  },
	  watch: {
	    items: function items() {
	      this.checkMeasures();
	    },
	    filtertext: function filtertext() {
	      this.checkMeasures();
	    }
	  },
	  ready: function ready() {
	    this.checkMeasures();
	    this.$dispatch('runDesignJQuery');
	  }
	};

/***/ }),
/* 23 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _stringify = __webpack_require__(2);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _Filter = __webpack_require__(14);
	
	var _Filter2 = _interopRequireDefault(_Filter);
	
	var _Fabrics = __webpack_require__(13);
	
	var _Fabrics2 = _interopRequireDefault(_Fabrics);
	
	var _Zoom = __webpack_require__(1);
	
	var _Zoom2 = _interopRequireDefault(_Zoom);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var jQuery = __webpack_require__(4);
	
	exports.default = {
	  name: 'Fabric',
	  data: function data() {
	    return {
	      fabricsLimit: 30,
	      showPattern: false,
	      showColor: false,
	      showWeave: false,
	      showMaterial: false,
	      showOccasion: false,
	      showPrice: false,
	      showName: false,
	      showSeason: false,
	      selectPrice: '49.90',
	      filtercolor: '',
	      filterpattern: '',
	      filterweave: '',
	      filtermaterial: '',
	      filteroccasion: '',
	      filtername: '',
	      fields: ['name', 'color', 'weave', 'season', 'occasion', 'pattern', 'material'],
	      boolfilter: { 'topseller': '0', 'new': '0' },
	      range1: { value: 49, min: 49, max: 100 },
	      range2: { value: 100, min: 50, max: 100 },
	      currentData: {},
	      globals: window.shirtdesigner,
	      translations: window.shirtdesigner.translations,
	      scrolling: false
	    };
	  },
	  components: {
	    Filter: _Filter2.default,
	    Fabrics: _Fabrics2.default,
	    Zoom: _Zoom2.default
	  },
	  props: {
	    'baseurl': String,
	    'personal': Object,
	    'fabrics': Array,
	    'zoom': Object,
	    'filtercolor': String,
	    'filterpattern': String,
	    'filterweave': String,
	    'filtermaterial': String,
	    'filteroccasion': String,
	    'filtername': String,
	    'muster1': String,
	    'muster2': String,
	    'muster3': String,
	    'muster4': String,
	    show: {
	      type: Boolean,
	      required: true,
	      twoWay: true
	    }
	  },
	  events: {
	    setFilter: function setFilter(event, callback) {
	      switch (event.currentTarget.dataset.select) {
	        case 'color':
	          if (event.currentTarget.id === 'all') {
	            this.filtercolor = '';
	            this.showColor = false;
	            callback('Color');
	          } else {
	            this.filtercolor = event.currentTarget.id;
	            callback(this.filtercolor);
	          }
	          break;
	        case 'pattern':
	          if (event.currentTarget.id === 'all') {
	            this.filterpattern = '';
	            this.showPattern = false;
	            callback('Pattern');
	          } else {
	            this.filterpattern = event.currentTarget.id;
	            callback(this.filterpattern);
	          }
	          break;
	        case 'weave':
	          if (event.currentTarget.id === 'all') {
	            this.filterweave = '';
	            this.showWeave = false;
	            callback('Weave');
	          } else {
	            this.filterweave = event.currentTarget.id;
	            callback(this.filterweave);
	          }
	          break;
	        case 'material':
	          if (event.currentTarget.id === 'all') {
	            this.filtermaterial = '';
	            this.showMaterial = false;
	            callback('Material');
	          } else {
	            this.filtermaterial = event.currentTarget.id;
	            callback(this.filtermaterial);
	          }
	          break;
	        case 'occasion':
	          if (event.currentTarget.id === 'all') {
	            this.filteroccasion = '';
	            this.showOccasion = false;
	            callback('Occasion');
	          } else {
	            this.filteroccasion = event.currentTarget.id;
	            callback(this.filteroccasion);
	          }
	          break;
	        case 'name':
	          this.filtername = event.currentTarget.value;
	          callback(this.filtername);
	          break;
	      }
	    },
	    checkDesign: function checkDesign(event) {
	      this.$dispatch('mainCheckDesign', event, function () {});
	    },
	    setBoolFilter: function setBoolFilter(event, callback) {
	      if (this.boolfilter[event.currentTarget.id] !== '1') {
	        this.boolfilter[event.currentTarget.id] = '1';
	        callback('1');
	      } else {
	        this.boolfilter[event.currentTarget.id] = '0';
	        callback('0');
	      }
	    },
	    resetFilter: function resetFilter() {
	      this.showPattern = false;
	      this.showColor = false;
	      this.showWeave = false;
	      this.showMaterial = false;
	      this.showOccasion = false;
	      this.showSeason = false;
	      this.showPrice = false;
	      this.showName = false;
	      this.range1.value = this.range1.min;
	      this.range2.value = this.range2.max;
	      this.resetBoolFilter();
	      this.filtercolor = '';
	      this.filterpattern = '';
	      this.filterweave = '';
	      this.filtermaterial = '';
	      this.filteroccasion = '';
	      this.filtername = '';
	    },
	    updatePersonal: function updatePersonal(event) {
	      window.shirtdesigner.extraPrices['fabric'] = Number(event.currentTarget.dataset.price).toFixed(2);
	      this.$dispatch('updatePersonalData', [event.currentTarget.dataset.component, event.currentTarget.id]);
	      this.$dispatch('updatePersonalData', ['fabric_quality', event.currentTarget.dataset.fabric_quality]);
	      this.setCurrentData(event.currentTarget.id);
	    }
	  },
	  methods: {
	    selectFabric: function selectFabric(event) {
	      this.$dispatch('getFabricData', event);
	    },
	    showFilter: function showFilter(event) {
	      this.resetFilter();
	      var t = event.currentTarget.id.substr(0, event.currentTarget.id.indexOf('Button'));
	      var f = 'show' + t.charAt(0).toUpperCase() + t.substr(1);
	      this[f] = 'true';
	    },
	    thumbUrl: function thumbUrl(event) {
	      return this.baseurl + event.currentTarget.dataset.thumb;
	    },
	    resetBoolFilter: function resetBoolFilter() {
	      var b;
	      for (b in this.boolfilter) {
	        this.boolfilter[b] = '0';
	      }
	    },
	    setCurrentData: function setCurrentData(sku) {
	      this.currentData = jQuery.grep(this.fabrics, function (e) {
	        return e.ref_number === sku;
	      })[0];
	    },
	    zoomFabric: function zoomFabric(event) {
	      this.zoom = {
	        img: this.baseurl + 'media/' + event.currentTarget.dataset.zoom,
	        title: event.currentTarget.dataset.title,
	        infotext: event.currentTarget.dataset.infotext,
	        weight: event.currentTarget.dataset.weight,
	        composition: event.currentTarget.dataset.composition,
	        weave: event.currentTarget.dataset.weave,
	        yarn: event.currentTarget.dataset.yarn,
	        refnr: event.currentTarget.dataset.refnr,
	        price: Number(event.currentTarget.dataset.price).toFixed(2)
	      };
	      this.show = true;
	    },
	    addMobileSample: function addMobileSample(event) {
	      var exists = false;
	      var message = '';
	      var free = '';
	      var keys = ['muster1', 'muster2', 'muster3', 'muster4'];
	      var i = 0;
	      var key;
	      while (keys[i]) {
	        key = keys[i];
	        if (localStorage.getItem(key)) {
	          if (event.currentTarget.dataset.refnr === JSON.parse(localStorage.getItem(key))) {
	            exists = key;
	            break;
	          }
	        } else {
	          if (!free) free = key;
	        }
	        i++;
	      }
	      if (!exists && free) {
	        localStorage.setItem(free, (0, _stringify2.default)(event.currentTarget.dataset.refnr));
	        this.$dispatch('setSwatch', { key: free, value: event.currentTarget.dataset.refnr });
	        this.$dispatch('setMsg', { success: this.translations['Added to swatch box.'] });
	      } else {
	        if (exists) {
	          localStorage.removeItem(key);
	          this.$dispatch('setSwatch', { key: key, value: '' });
	          message = this.translations['Removed from swatch box.'];
	          this.$dispatch('setMsg', { success: message });
	        } else {
	          message = this.translations['You have already four fabrics in swatch box.'];
	          this.$dispatch('setMsg', { error: message });
	        }
	      }
	    }
	  },
	  created: function created() {
	    jQuery.getJSON(this.baseurl + '/designer/ajax/getFabricList', { type: 'shirt' }, function (data) {
	      this.fabrics = data;
	      this.setCurrentData(this.personal['fabric']);
	    }.bind(this));
	    this.box = { 'component': 'fabric', 'title': window.shirtdesigner.translations['Fabric'], 'todo': window.shirtdesigner.translations['Choose from these fabrics.'], 'active': true };
	  },
	  ready: function ready() {
	    this.$dispatch('runDesignJQuery');
	  }
	};

/***/ }),
/* 24 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Zoom = __webpack_require__(1);
	
	var _Zoom2 = _interopRequireDefault(_Zoom);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'Fit',
	  data: function data() {
	    return {
	      globals: window.shirtdesigner,
	      show: {
	        type: Boolean,
	        required: true,
	        twoWay: true
	      }
	    };
	  },
	  props: ['fabrics', 'items', 'box', 'filtertext', 'zoom', 'show', 'baseurl', 'personal', 'isactive', 'personal', 'selectBoxes'],
	  components: {
	    Zoom: _Zoom2.default
	  },
	  methods: {
	    updatePersonal: function updatePersonal(event) {
	      this.$dispatch('updatePersonalData', [event.currentTarget.dataset.component, event.currentTarget.id]);
	      if (event.currentTarget.dataset.btncolor) {
	        this.$dispatch('updatePersonalData', ['button-color', event.currentTarget.dataset.btncolor]);
	      }
	      this.isactive = event.currentTarget.id;
	      if (event.currentTarget.dataset.component === 'sleeve' && event.currentTarget.id !== 'long' && (this.personal['monopos'] === 'cuffleft' || this.personal['monopos'] === 'cuffright')) {
	        this.$dispatch('updatePersonalData', ['monogramm', '']);
	        this.$dispatch('updatePersonalData', ['monopos', 'waistleft']);
	      }
	    },
	    zoomFabric: function zoomFabric(event) {
	      this.zoom = {
	        img: this.baseurl + 'media/jack/shirt/zoom/' + this.box.component + '_' + event.currentTarget.dataset.refnr + '.jpg',
	        title: event.currentTarget.dataset.title,
	        infotext: event.currentTarget.dataset.infotext,
	        weight: event.currentTarget.dataset.weight,
	        composition: event.currentTarget.dataset.composition,
	        weave: event.currentTarget.dataset.weave,
	        yarn: event.currentTarget.dataset.yarn,
	        refnr: event.currentTarget.dataset.refnr,
	        price: Number(event.currentTarget.dataset.price).toFixed(2)
	      };
	      this.show = true;
	    }
	  },
	  ready: function ready() {
	    this.$dispatch('runDesignJQuery');
	  }
	};

/***/ }),
/* 25 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  name: 'Hankerchief',
	  props: ['fabrics', 'items', 'box', 'filtertext', 'personal', 'isactive', 'translations'],
	  data: function data() {
	    return {
	      selected: typeof this.personal['hankerchief'] !== 'undefined' ? this.personal['hankerchief'] : '',
	      selectedlogo: typeof this.personal['tj_logo'] !== 'undefined' ? this.personal['tj_logo'] : ''
	    };
	  },
	  methods: {
	    updatePersonal: function updatePersonal(event) {
	      if (event.currentTarget.id === 'hankerchief') {
	        this.$dispatch('updatePersonalData', [event.currentTarget.id, this.selected]);
	      } else if (event.currentTarget.id === 'tj_logo') {
	        this.$dispatch('updatePersonalData', [event.currentTarget.id, this.selectedlogo]);
	      }
	    }
	  },
	  ready: function ready() {
	    this.$dispatch('runDesignJQuery');
	  }
	};

/***/ }),
/* 26 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  name: 'Monogramm',
	  props: ['fabrics', 'items', 'box', 'filtertext', 'baseurl', 'personal', 'translations', 'isactive', 'sleeve'],
	  data: function data() {
	    return {
	      selected: this.personal['monopos'] ? this.personal['monopos'] : '',
	      fontselect: this.personal['monogramm_font'] ? this.personal['monogramm_font'] : '',
	      message: this.personal['monogramm'] ? this.personal['monogramm'] : '',
	      personal: this.personal,
	      images: [],
	      image: window.shirtdesigner.image,
	      scrolling: false,
	      touchstart: false,
	      scrollPosition: 0,
	      translations: window.shirtdesigner.translations,
	      selectedScrollHeight: document.getElementById(this.box.component + '_yarn') ? document.getElementById(this.box.component + '_yarn').scrollHeight : 0,
	      selectedClientHeight: document.getElementById(this.box.component + '_yarn') ? document.getElementById(this.box.component + '_yarn').clientHeight : 0,
	      isactive: this.personal['monogramm_yarn'] ? this.personal['monogramm_yarn'] : 'neutral'
	    };
	  },
	  methods: {
	    updatePersonalMonogramm: function updatePersonalMonogramm(event) {
	      var value = '';
	      switch (event.currentTarget.id) {
	        case 'monogramm':
	          value = this.message;
	          var check = value.replace(/\./g, '').length;
	          if (check > 3) {
	            value = value.slice(0, -1);
	            this.message = value;
	          }
	          break;
	        case 'monopos':
	          value = this.selected;
	          break;
	        case 'monogramm_font':
	          value = this.fontselect;
	          break;
	        case 'monogramm_yarn':
	          value = event.currentTarget.dataset.yarncolor;
	          break;
	        default:
	          break;
	      }
	      this.$dispatch('updatePersonalData', [event.currentTarget.id, value]);
	
	      var pos = localStorage.getItem('monopos') ? JSON.parse(localStorage['monopos']) : 'waistleft';
	
	      if (this.message !== '') {
	        this.$dispatch('updateMonoPosition', pos);
	      }
	    },
	    updatePersonal: function updatePersonal(event) {
	      this.$dispatch('updatePersonalData', [event.currentTarget.dataset.component, event.currentTarget.id]);
	      if (typeof event.currentTarget.dataset.yarncolor !== 'undefined') {
	        if (event.currentTarget.dataset.yarncolor !== 'neutral') {
	          this.$dispatch('updatePersonalData', ['monogramm-color', event.currentTarget.dataset.yarncolor]);
	          this.$dispatch('updatePersonalData', ['monogramm_yarn', event.currentTarget.dataset.yarncolor]);
	          this.isactive = event.currentTarget.dataset.yarncolor;
	        } else {
	          var rgb = this.colorFinder(document.getElementsByClassName('img-fit')[0]);
	          var neutralColor = this.componentToHex(rgb.r) + this.componentToHex(rgb.g) + this.componentToHex(rgb.b);
	          this.$dispatch('updatePersonalData', ['monogramm-color', neutralColor]);
	          this.$dispatch('updatePersonalData', ['monogramm_yarn', 'neutral']);
	          this.isactive = 'neutral';
	        }
	      }
	    },
	    resetMonogramm: function resetMonogramm(event) {
	      this.message = '';
	      this.$dispatch('updatePersonalData', ['monogramm', this.message]);
	    },
	    imgUrl: function imgUrl(color) {
	      if (color !== 'neutral') {
	        return this.baseurl + 'designer/image/colorize/color/' + color + '/img/mask_buttonhole_yarn.png';
	      } else {
	        return this.baseurl + 'media/upload/image/dummy_product_small.jpg';
	      }
	    },
	    scrolldown: function scrolldown() {
	      if (this.touchstart === false) {
	        var ele = document.getElementById(this.box.component + '_yarn');
	        var speed = 25;
	        var scroll = 5;
	        var $this = this;
	        this.scrolling = window.setInterval(function () {
	          ele.scrollTop = ele.scrollTop + scroll;
	          $this.itemsScroll();
	        }, speed);
	      }
	    },
	    scrollup: function scrollup() {
	      if (this.touchstart === false) {
	        var ele = document.getElementById(this.box.component + '_yarn');
	        var speed = 25;
	        var scroll = 5;
	        var $this = this;
	        this.scrolling = window.setInterval(function () {
	          ele.scrollTop = ele.scrollTop - scroll;
	          $this.itemsScroll();
	        }, speed);
	      }
	    },
	    mouseleave: function mouseleave() {
	      if (this.scrolling) {
	        window.clearInterval(this.scrolling);
	        this.scrolling = false;
	      }
	    },
	    touchstartup: function touchstartup() {
	      this.touchstart = true;
	      var ele = document.getElementById(this.box.component + '_yarn');
	      var speed = 25;
	      var scroll = 5;
	      var $this = this;
	      this.scrolling = window.setInterval(function () {
	        ele.scrollTop = ele.scrollTop - scroll;
	        $this.itemsScroll();
	      }, speed);
	    },
	    touchstartdown: function touchstartdown() {
	      this.touchstart = true;
	      var ele = document.getElementById(this.box.component + '_yarn');
	      var speed = 25;
	      var scroll = 5;
	      var $this = this;
	      this.scrolling = window.setInterval(function () {
	        ele.scrollTop = ele.scrollTop + scroll;
	        $this.itemsScroll();
	      }, speed);
	    },
	    touchend: function touchend() {
	      this.mouseleave();
	    },
	    colorFinder: function colorFinder(imgEl) {
	      var blockSize = 5;
	      var defaultRGB = { r: 0, g: 0, b: 0 };
	      var canvas = document.createElement('canvas');
	      var context = canvas.getContext && canvas.getContext('2d');
	      var data;
	      var width;
	      var height;
	      var i = -4;
	      var length;
	      var rgb = { r: 0, g: 0, b: 0 };
	      var count = 0;
	
	      if (!context) {
	        return defaultRGB;
	      }
	
	      height = canvas.height = imgEl.naturalHeight || imgEl.offsetHeight || imgEl.height;
	      width = canvas.width = imgEl.naturalWidth || imgEl.offsetWidth || imgEl.width;
	
	      context.drawImage(imgEl, 0, 0);
	
	      try {
	        data = context.getImageData(0, 0, width, height);
	      } catch (e) {
	        return defaultRGB;
	      }
	      length = data.data.length;
	      while ((i += blockSize * 4) < length) {
	        ++count;
	        rgb.r += data.data[i];
	        rgb.g += data.data[i + 1];
	        rgb.b += data.data[i + 2];
	      }
	
	      rgb.r = ~~(rgb.r / count);
	      rgb.g = ~~(rgb.g / count);
	      rgb.b = ~~(rgb.b / count);
	
	      return rgb;
	    },
	    componentToHex: function componentToHex(c) {
	      var hex = c.toString(16);
	      return hex.length === 1 ? '0' + hex : hex;
	    },
	    checkMeasures: function checkMeasures() {
	      this.selectedScrollHeight = document.getElementById(this.box.component + '_yarn') ? document.getElementById(this.box.component + '_yarn').scrollHeight : 0;
	      this.selectedClientHeight = document.getElementById(this.box.component + '_yarn') ? document.getElementById(this.box.component + '_yarn').clientHeight : 0;
	    },
	    itemsScroll: function itemsScroll() {
	      var ele = document.getElementById(this.box.component + '_yarn');
	      this.scrollPosition = ele.scrollTop;
	      this.checkMeasures();
	    }
	  },
	  created: function created() {
	    this.message = localStorage.getItem('monogramm') ? JSON.parse(localStorage['monogramm']) : '';
	    if (this.message === 'no_monogramm') {
	      this.message = '';
	    }
	    var pos = localStorage.getItem('monopos') ? JSON.parse(localStorage['monopos']) : 'waistleft';
	    this.$dispatch('updateMonoPosition', pos);
	    this.isactive = this.personal['monogramm_yarn'] ? this.personal['monogramm_yarn'] : 'neutral';
	  },
	  watch: {
	    yarns: function yarns() {
	      this.checkMeasures();
	    },
	    filtertext: function filtertext() {
	      this.checkMeasures();
	    }
	  },
	  ready: function ready() {
	    this.checkMeasures();
	    this.$dispatch('runDesignJQuery');
	  }
	};

/***/ }),
/* 27 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  name: 'Yarnbuttonhole',
	  props: ['fabrics', 'items', 'box', 'filtertext', 'baseurl', 'personal', 'isactive'],
	  data: function data() {
	    return {
	      scrolling: false,
	      touchstart: false,
	      translations: window.shirtdesigner.translations,
	      scrollPosition: 0,
	      selectedScrollHeight: document.getElementById(this.box.component) ? document.getElementById(this.box.component).scrollHeight : 0,
	      selectedClientHeight: document.getElementById(this.box.component) ? document.getElementById(this.box.component).clientHeight : 0
	    };
	  },
	  methods: {
	    updatePersonal: function updatePersonal(event) {
	      this.$dispatch('updatePersonalData', [event.currentTarget.dataset.component, event.currentTarget.id]);
	      this.isactive = event.currentTarget.id;
	    },
	    imgUrl: function imgUrl(color) {
	      if (color !== 'neutral') {
	        return this.baseurl + 'designer/image/colorize/color/' + color + '/img/mask_buttonhole_yarn.png';
	      } else {
	        return this.baseurl + 'media/upload/image/dummy_product_small.jpg';
	      }
	    },
	    scrolldown: function scrolldown() {
	      if (this.touchstart === false) {
	        var ele = document.getElementById(this.box.component);
	        var speed = 25;
	        var scroll = 5;
	        var $this = this;
	        this.scrolling = window.setInterval(function () {
	          ele.scrollTop = ele.scrollTop + scroll;
	          $this.itemsScroll();
	        }, speed);
	      }
	    },
	    scrollup: function scrollup() {
	      if (this.touchstart === false) {
	        var ele = document.getElementById(this.box.component);
	        var speed = 25;
	        var scroll = 5;
	        var $this = this;
	        this.scrolling = window.setInterval(function () {
	          ele.scrollTop = ele.scrollTop - scroll;
	          $this.itemsScroll();
	        }, speed);
	      }
	    },
	    mouseleave: function mouseleave() {
	      if (this.scrolling) {
	        window.clearInterval(this.scrolling);
	        this.scrolling = false;
	      }
	    },
	    touchstartup: function touchstartup() {
	      this.touchstart = true;
	      var ele = document.getElementById(this.box.component);
	      var speed = 25;
	      var scroll = 5;
	      var $this = this;
	      this.scrolling = window.setInterval(function () {
	        ele.scrollTop = ele.scrollTop - scroll;
	        $this.itemsScroll();
	      }, speed);
	    },
	    touchstartdown: function touchstartdown() {
	      this.touchstart = true;
	      var ele = document.getElementById(this.box.component);
	      var speed = 25;
	      var scroll = 5;
	      var $this = this;
	      this.scrolling = window.setInterval(function () {
	        ele.scrollTop = ele.scrollTop + scroll;
	        $this.itemsScroll();
	      }, speed);
	    },
	    touchend: function touchend() {
	      this.mouseleave();
	    },
	    checkMeasures: function checkMeasures() {
	      this.selectedScrollHeight = document.getElementById(this.box.component) ? document.getElementById(this.box.component).scrollHeight : 0;
	      this.selectedClientHeight = document.getElementById(this.box.component) ? document.getElementById(this.box.component).clientHeight : 0;
	    },
	    itemsScroll: function itemsScroll() {
	      var ele = document.getElementById(this.box.component);
	      this.scrollPosition = ele.scrollTop;
	      this.checkMeasures();
	    }
	  },
	  watch: {
	    fabrics: function fabrics() {
	      this.checkMeasures();
	    }
	  },
	  ready: function ready() {
	    this.checkMeasures();
	    this.$dispatch('runDesignJQuery');
	  }
	};

/***/ }),
/* 28 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _stringify = __webpack_require__(2);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _Zoom = __webpack_require__(1);
	
	var _Zoom2 = _interopRequireDefault(_Zoom);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'Fabrics',
	  components: {
	    Zoom: _Zoom2.default
	  },
	  props: ['baseurl', 'box', 'fabrics', 'filtercolor', 'showcolor', 'filterpattern', 'showpattern', 'filterweave', 'showweave', 'filtermaterial', 'showmaterial', 'filteroccasion', 'showoccasion', 'filtername', 'showname', 'range1', 'range2', 'showprice', 'boolfilter', 'fields', 'personal', 'muster1', 'muster2', 'muster3', 'muster4', 'zoom'],
	  data: function data() {
	    return {
	      isactive: '',
	      show: {
	        type: Boolean,
	        required: true,
	        twoWay: true
	      },
	      globals: window.shirtdesigner,
	      scrolling: false,
	      touchstart: false,
	      translations: window.shirtdesigner.translations,
	      selectedScrollHeight: document.getElementById(this.box.component) ? document.getElementById(this.box.component).scrollHeight : 0,
	      selectedClientHeight: document.getElementById(this.box.component) ? document.getElementById(this.box.component).clientHeight : 0,
	      scrollPosition: 0
	    };
	  },
	  methods: {
	    updatePersonal: function updatePersonal(event) {
	      this.$dispatch('updatePersonal', event);
	      this.isactive = event.currentTarget.id;
	    },
	    priceBetween: function priceBetween(a) {
	      if (a.price >= this.range1.value && a.price <= this.range2.value) {
	        return a;
	      }
	    },
	    topseller: function topseller(a) {
	      if (this.boolfilter['topseller'] === '1') {
	        if (a.topseller === '1') return a;
	      } else {
	        return a;
	      }
	    },
	    newFilter: function newFilter(a) {
	      if (this.boolfilter['new'] === '1') {
	        if (a.new === '1') return a;
	      } else {
	        return a;
	      }
	    },
	    zoomFabric: function zoomFabric(event) {
	      this.zoom = {
	        img: this.baseurl + 'media/' + event.currentTarget.dataset.zoom,
	        title: event.currentTarget.dataset.title,
	        infotext: event.currentTarget.dataset.infotext,
	        weight: event.currentTarget.dataset.weight,
	        composition: event.currentTarget.dataset.composition,
	        weave: event.currentTarget.dataset.weave,
	        yarn: event.currentTarget.dataset.yarn,
	        refnr: event.currentTarget.dataset.refnr,
	        price: Number(event.currentTarget.dataset.price).toFixed(2)
	      };
	      this.show = true;
	    },
	    addSample: function addSample(event) {
	      var exists = false;
	      var message = '';
	      var free = '';
	      var keys = ['muster1', 'muster2', 'muster3', 'muster4'];
	      var i = 0;
	      var key;
	      while (keys[i]) {
	        key = keys[i];
	        if (localStorage.getItem(key)) {
	          if (event.currentTarget.dataset.refnr === JSON.parse(localStorage.getItem(key))) {
	            exists = key;
	            break;
	          }
	        } else {
	          if (!free) free = key;
	        }
	        i++;
	      }
	      if (!exists && free) {
	        localStorage.setItem(free, (0, _stringify2.default)(event.currentTarget.dataset.refnr));
	        this.$dispatch('setSwatch', { key: free, value: event.currentTarget.dataset.refnr });
	        this.$dispatch('setMsg', { success: this.translations['Added to swatch box.'] });
	      } else {
	        if (exists) {
	          localStorage.removeItem(key);
	          this.$dispatch('setSwatch', { key: key, value: '' });
	          message = this.translations['Removed from swatch box.'];
	          this.$dispatch('setMsg', { success: message });
	        } else {
	          message = this.translations['You have already four fabrics in swatch box.'];
	          this.$dispatch('setMsg', { error: message });
	        }
	      }
	    },
	    scrolldown: function scrolldown() {
	      if (this.touchstart === false) {
	        var ele = document.getElementById(this.box.component);
	        var speed = 25;
	        var scroll = 5;
	        var $this = this;
	        this.scrolling = window.setInterval(function () {
	          ele.scrollTop = ele.scrollTop + scroll;
	          $this.itemsScroll();
	        }, speed);
	      }
	    },
	    scrollup: function scrollup() {
	      if (this.touchstart === false) {
	        var ele = document.getElementById(this.box.component);
	        var speed = 25;
	        var scroll = 5;
	        var $this = this;
	        this.scrolling = window.setInterval(function () {
	          ele.scrollTop = ele.scrollTop - scroll;
	          $this.itemsScroll();
	        }, speed);
	      }
	    },
	    mouseleave: function mouseleave() {
	      if (this.scrolling) {
	        window.clearInterval(this.scrolling);
	        this.scrolling = false;
	      }
	    },
	    touchstartup: function touchstartup() {
	      this.touchstart = true;
	      var ele = document.getElementById(this.box.component);
	      var speed = 25;
	      var scroll = 5;
	      var $this = this;
	      this.scrolling = window.setInterval(function () {
	        ele.scrollTop = ele.scrollTop - scroll;
	        $this.itemsScroll();
	      }, speed);
	    },
	    touchstartdown: function touchstartdown() {
	      this.touchstart = true;
	      var ele = document.getElementById(this.box.component);
	      var speed = 25;
	      var scroll = 5;
	      var $this = this;
	      this.scrolling = window.setInterval(function () {
	        ele.scrollTop = ele.scrollTop + scroll;
	        $this.itemsScroll();
	      }, speed);
	    },
	    touchend: function touchend() {
	      this.mouseleave();
	    },
	    checkMeasures: function checkMeasures() {
	      this.selectedScrollHeight = document.getElementById(this.box.component) ? document.getElementById(this.box.component).scrollHeight : 0;
	      this.selectedClientHeight = document.getElementById(this.box.component) ? document.getElementById(this.box.component).clientHeight : 0;
	    },
	    itemsScroll: function itemsScroll() {
	      var ele = document.getElementById(this.box.component);
	      this.scrollPosition = ele.scrollTop;
	      this.checkMeasures();
	    }
	  },
	  watch: {
	    fabrics: function fabrics() {
	      this.checkMeasures();
	    },
	    filtercolor: function filtercolor() {
	      this.checkMeasures();
	    },
	    showcolor: function showcolor() {
	      this.checkMeasures();
	    },
	    filterpattern: function filterpattern() {
	      this.checkMeasures();
	    },
	    showpattern: function showpattern() {
	      this.checkMeasures();
	    },
	    filterweave: function filterweave() {
	      this.checkMeasures();
	    },
	    showweave: function showweave() {
	      this.checkMeasures();
	    },
	    filtermaterial: function filtermaterial() {
	      this.checkMeasures();
	    },
	    showmaterial: function showmaterial() {
	      this.checkMeasures();
	    },
	    filteroccasion: function filteroccasion() {
	      this.checkMeasures();
	    },
	    showoccasion: function showoccasion() {
	      this.checkMeasures();
	    },
	    filtername: function filtername() {
	      this.checkMeasures();
	    },
	    showname: function showname() {
	      this.checkMeasures();
	    },
	    range1: function range1() {
	      this.checkMeasures();
	    },
	    range2: function range2() {
	      this.checkMeasures();
	    },
	    showprice: function showprice() {
	      this.checkMeasures();
	    },
	    boolfilter: function boolfilter() {
	      this.checkMeasures();
	    }
	  },
	  ready: function ready() {
	    this.checkMeasures();
	  }
	};

/***/ }),
/* 29 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  name: 'Filter',
	  data: function data() {
	    return {
	      translations: window.shirtdesigner.translations
	    };
	  },
	  props: {
	    showPattern: Boolean,
	    showColor: Boolean,
	    showWeave: Boolean,
	    showMaterial: Boolean,
	    showOccasion: Boolean,
	    showPrice: Boolean,
	    showSeason: Boolean,
	    showNew: Boolean,
	    showTopseller: Boolean,
	    showName: Boolean,
	    filtercolor: String,
	    buttonColor: String,
	    classcolor: String,
	    filterpattern: String,
	    buttonPattern: String,
	    classpattern: String,
	    filterweave: String,
	    buttonWeave: String,
	    classweave: String,
	    filtermaterial: String,
	    buttonMaterial: String,
	    classmaterial: String,
	    filteroccasion: String,
	    buttonOccasion: String,
	    classoccasion: String,
	    buttonNew: String,
	    buttonTopseller: String,
	    buttonPrice: String,
	    filtername: String,
	    buttonName: String,
	    range1: Object,
	    range2: Object,
	    boolfilter: Object
	  },
	  methods: {
	    selectFabric: function selectFabric(event) {
	      this.$dispatch('getFabricData', event);
	    },
	    setFilter: function setFilter(event) {
	      var t = event.currentTarget.dataset.select;
	      var f = 'show' + t.charAt(0).toUpperCase() + t.substr(1);
	      var id = event.currentTarget.id === 'all' ? '' : event.currentTarget.id;
	      var cl = 'class' + t;
	      this[cl] = id.replace('100%', 'full');
	      this[f] = false;
	      this.$dispatch('setFilter', event, function (value) {
	        var b = 'button' + t.charAt(0).toUpperCase() + t.substr(1);
	        this[b] = window.shirtdesigner.translations[value];
	      }.bind(this));
	      this.$dispatch('checkDesign', event, function () {});
	    },
	    setBoolFilter: function setBoolFilter(event) {
	      var t = event.currentTarget.id.substr(0, event.currentTarget.id.indexOf('Button'));
	      var f = 'show' + t.charAt(0).toUpperCase() + t.substr(1);
	      if (this[f] === true) {
	        this[f] = false;
	      } else {
	        this.resetFilter();
	        this[f] = true;
	      }
	      this.$dispatch('setBoolFilter', event, function () {});
	      this.$dispatch('checkDesign', event, function () {});
	    },
	    resetFilter: function resetFilter(event) {
	      this.showPattern = false;
	      this.showColor = false;
	      this.showWeave = false;
	      this.showMaterial = false;
	      this.showOccasion = false;
	      this.showSeason = false;
	      this.showPrice = false;
	      this.showName = false;
	      this.$dispatch('checkDesign', event, function () {});
	    },
	    realResetFilter: function realResetFilter() {
	      this.resetFilter();
	      this.$dispatch('resetFilter');
	      this.resetButtons();
	    },
	    showFilter: function showFilter(event) {
	      var t = event.currentTarget.id.substr(0, event.currentTarget.id.indexOf('Button'));
	      var f = 'show' + t.charAt(0).toUpperCase() + t.substr(1);
	      if (this[f] === true) {
	        this[f] = false;
	      } else {
	        this.resetFilter();
	        this[f] = true;
	      }
	      this.$dispatch('checkDesign', event, function () {});
	    },
	    closeName: function closeName() {
	      this.showName = false;
	    },
	    closePrice: function closePrice() {
	      this.showPrice = false;
	    },
	    range1max: function range1max() {
	      this.range1.max = this.range2.value;
	      if (this.range1.value !== this.range1.min || this.range2.value !== this.range2.max) {
	        this.buttonPrice = this.range1.value + ' - ' + this.range2.value + ' €';
	      } else {
	        this.buttonPrice = window.shirtdesigner.translations['Price'];
	      }
	    },
	    range2min: function range2min() {
	      this.range2.min = this.range1.value;
	      if (this.range1.value !== this.range1.min || this.range2.value !== this.range2.max) {
	        this.buttonPrice = this.range1.value + ' - ' + this.range2.value + ' €';
	      } else {
	        this.buttonPrice = window.shirtdesigner.translations['Price'];
	      }
	    },
	    nameChange: function nameChange(event) {
	      var t = event.currentTarget.dataset.select;
	      this.$dispatch('setFilter', event, function (value) {
	        var b = 'button' + t.charAt(0).toUpperCase() + t.substr(1);
	        if (value === '') {
	          this[b] = window.shirtdesigner.translations['Name'];
	        } else {
	          this[b] = value;
	        }
	      }.bind(this));
	    },
	    setPriceRange: function setPriceRange(event) {
	      var min = parseInt(event.currentTarget.dataset.start);
	      var max = parseInt(event.currentTarget.dataset.end);
	      this.range1.value = min;
	      this.range2min();
	      this.range2.value = max;
	      this.range1max();
	      this.closePrice();
	    },
	    resetButtons: function resetButtons() {
	      this.buttonColor = window.shirtdesigner.translations['Color'];
	      this.buttonPattern = window.shirtdesigner.translations['Pattern'];
	      this.buttonPrice = window.shirtdesigner.translations['Price'];
	      this.buttonWeave = window.shirtdesigner.translations['Weave'];
	      this.buttonMaterial = window.shirtdesigner.translations['Material'];
	      this.buttonNew = window.shirtdesigner.translations['New fabrics'];
	      this.buttonTopseller = window.shirtdesigner.translations['Topseller'];
	      this.buttonOccasion = window.shirtdesigner.translations['Occasion'];
	      this.buttonName = window.shirtdesigner.translations['Name'];
	      this.filtername = '';
	      this.classpattern = '';
	      this.classcolor = '';
	      this.classweave = '';
	      this.classmaterial = '';
	      this.classoccasion = '';
	    }
	  },
	  created: function created() {
	    this.resetButtons();
	  }
	};

/***/ }),
/* 30 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _stringify = __webpack_require__(2);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var jQuery = __webpack_require__(4);
	
	exports.default = {
	  name: 'Zoom',
	  props: ['zoom', 'show', 'globals', 'muster1', 'muster2', 'muster3', 'muster4'],
	  data: function data() {
	    var calcBottom = (100 + (110 - parseInt(this.zoom.weight)) / 2) * -1;
	    return {
	      bottomWeight: calcBottom,
	      translations: window.shirtdesigner.translations
	    };
	  },
	  methods: {
	    addSample: function addSample(event) {
	      var exists = false;
	      var message = '';
	      var free = '';
	      var keys = ['muster1', 'muster2', 'muster3', 'muster4'];
	      var i = 0;
	      var key;
	      while (keys[i]) {
	        key = keys[i];
	        if (localStorage.getItem(key)) {
	          if (event.currentTarget.dataset.refnr === JSON.parse(localStorage.getItem(key))) {
	            exists = key;
	            break;
	          }
	        } else {
	          if (!free) free = key;
	        }
	        i++;
	      }
	      if (!exists && free) {
	        localStorage.setItem(free, (0, _stringify2.default)(event.currentTarget.dataset.refnr));
	        this.$dispatch('setSwatch', { key: free, value: event.currentTarget.dataset.refnr });
	        this.$dispatch('setMsg', { success: this.translations['Added to swatch box.'] });
	      } else {
	        if (exists) {
	          localStorage.removeItem(key);
	          this.$dispatch('setSwatch', { key: key, value: '' });
	          message = this.translations['Removed from swatch box.'];
	          this.$dispatch('setMsg', { success: message });
	        } else {
	          message = this.translations['You have already four fabrics in swatch box.'];
	          this.$dispatch('setMsg', { error: message });
	        }
	      }
	    },
	    bodyZoom: function bodyZoom() {
	      if (this.show) {
	        jQuery('body').css('overflow', 'hidden');
	        jQuery('body').css('position', 'fixed');
	        jQuery('body').css('left', 0);
	        jQuery('body').css('right', 0);
	      } else {
	        jQuery('body').css('overflow', 'auto');
	        jQuery('body').css('position', 'relative');
	        jQuery('body').css('left', 'inherit');
	        jQuery('body').css('right', 'inherit');
	      }
	    }
	  },
	  watch: {
	    show: function show() {
	      this.bodyZoom();
	    }
	  },
	  created: function created() {
	    this.bodyZoom();
	  }
	};

/***/ }),
/* 31 */,
/* 32 */,
/* 33 */,
/* 34 */,
/* 35 */,
/* 36 */,
/* 37 */,
/* 38 */,
/* 39 */,
/* 40 */,
/* 41 */,
/* 42 */,
/* 43 */,
/* 44 */,
/* 45 */,
/* 46 */,
/* 47 */,
/* 48 */,
/* 49 */,
/* 50 */,
/* 51 */,
/* 52 */,
/* 53 */,
/* 54 */,
/* 55 */,
/* 56 */,
/* 57 */,
/* 58 */,
/* 59 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 60 */
/***/ (function(module, exports) {

	module.exports = " <div v-bind:class=\"['shirt-designer', (is_touch_device ? 'touch-enabled' : 'touch-disabled') ]\" id=konfigurator> <div class=preview-col> <div class=\"top-step-name mobile basic-border basic-color\">{{{ currentStep }}}<span class=extra_price v-bind:style=\"[(currentPrice !== '' ? {visibility: 'visible'} : {visibility: 'hidden'})]\"> + {{ currentPrice }} €</span> </div> <div class=sticky-wrapper> <div v-if=\"count < (views.length-1)\" class=designer-content-col id=shirtpreview> <div class=designer-img-shirt> <img v-if=false class=img-blocker v-bind:src=invurl /> <img v-if=\"personal['monogramm'] !== '' && personal['monogramm'] !== 'no_monogramm'\" class=img-monogramm v-bind:src=monogrammUrl /> <img v-if=\"personal['front'] !== 'hidden'\" class=img-buttons-front v-bind:src=buttonsFrontUrl /> <img v-if=\"personal['sleeve']!== 'short' && personal['sleeve']!='shortbar'\" class=img-buttons-cuff v-bind:src=buttonsCuffUrl /> <div v-bind:class=\"['collar-container', personal['collar'] ]\"> <img class=img-buttons-collar v-bind:src=buttonsCollarUrl /> <img v-if=\"personal['yarnbuttonhole'] !== 'neutral'\" class=img-yarn-collar v-bind:src=yarnCollarUrl /> <img class=img-collar-wings v-bind:src=collarWingsUrl /> <img class=img-collar-stand v-bind:src=collarStandUrl /> <img class=img-collar-innerback v-bind:src=collarInnerBackUrl /> <img v-bind:class=\"['img-collar-innerstand', personal['collar'] ]\" v-bind:src=collarInnerStandUrl /> </div> <img v-if=\"personal['front'] === 'hidden' && personal['yarnbuttonhole'] !== 'neutral'\" class=img-yarn-front v-bind:src=yarnFrontUrl /> <img v-if=\"personal['sleeve']!='short' && personal['sleeve']!='shortbar' && personal['yarnbuttonhole'] !== 'neutral'\" class=img-yarn-cuff v-bind:src=yarnCuffUrl /> <img v-if=\"personal['front'] === 'sewed'\" class=img-front v-bind:src=frontUrl /> <img v-if=\"personal['contrast_bs_upper_outside'] !== 'none'\" class=img-button-stripe v-bind:src=buttonStripeUrl /> <img v-if=\"personal['bags'] !== 'none'\" class=img-bags v-bind:src=bagsUrl /> <img v-if=\"personal['sleeve']!== 'short' && personal['sleeve']!='shortbar'\" class=img-cuff v-bind:src=cuffUrl /> <img v-if=\"personal['sleeve']!== 'short' && personal['sleeve']!='shortbar'\" class=img-cuff-inner v-bind:src=cuffInnerUrl /> <img class=img-sleeve v-bind:src=sleeveUrl /> <img class=img-fit v-bind:id=\"personal['fabric']\" v-bind:src=fitUrl /> </div> <div class=designer-imgtopbot-box> <p class=tax-details><span class=tax-details>{{{ imgcaption }}}</span></p> </div> </div> <div v-if=\"count >= (views.length-1)\" class=designer-content-col-mid> <div class=designer-attributesbox> <div v-if=\"isloggedin === 'false'\" class=login> <p style=\"clear: both\">Bitte melden Sie sich an, um Ihr Maßprofil auswählen zu können.</p> {{{ measurementblock }}} </div> <div v-if=\"isloggedin === 'true'\" class=tocart> <h4 v-if=\"measurementblock.length > 1\">Eigenes Maßprofil wählen</h4> <p v-if=\"measurementblock.length > 1\">Wenn Sie bereits ein Maßprofil hinterlegt haben oder eine Anfertigung nach Konfektionsmaßen wünschen, können Sie hier Ihr Wunschprofil auswählen.</p> <h4 v-if=\"measurementblock.length <= 1\">Eigenes Maßprofil erstellen</h4> <p v-if=\"measurementblock.length <= 1\">Erstellen Sie jetzt in wenigen Schritten Ihr individuelles Maßprofil.</p> <div class=designer-select> <a href=\"{{ measurementUrl }}\"> <button class=button title=\"{{ translations['Create mesurement profile'] }}\" type=button> <span>{{ translations['Create mesurement profile'] }}</span> </button> </a> <select v-if=\"measurementblock.length > 1\" name=setMeasurement id=shirtdesigner-measurement-select class=designer-measurement-select title=\"\" @change=addToCart> <option v-for=\"option in measurementblock\" :value=option.value>{{ option.label }} </option> </select> </div> <a id=ajax_events_cart href=\"\"></a> <div v-if=selectItems> <form :action=selectItems.checkoutUrl method=post id=product_addtocart_form enctype=multipart/form-data> <button id=tocart class=button title=\"In den Warenkorb\" type=button @click=clearViewCount> <span>{{ addToCartText }}</span> </button> <input v-for=\"item in selectItems.shirt\" type=text class=\"input-text required-entry product-custom-option\" :name=\"'options['+item.id+']'\" :id=$key :value=item.val style=display:none> <input v-for=\"item in selectItems.tab\" v-if=item.data.length type=text class=\"input-text required-entry product-custom-option\" :name=\"'options['+item.id+']'\" :id=$key :value=item.data style=display:none> </form> <button class=\"button summary\" title=Bestelldetails type=button @click=showSummary> <span>Bestelldetails</span> </button> </div> </div> </div> <div class=designer-detailbox id=addtocart-form-container> <div class=designer-detailbox-picture style=display:none> <a id=ajax_default href=\"\"></a> </div> </div> </div> </div> <div style=clear:both></div> </div> <component :is=currentView :fabrics=fabrics :items=selectItems :box=selectBox :zoom=zoom :show.sync=showModal :personal=personal :muster1=muster1 :muster2=muster2 :muster3=muster3 :muster4=muster4 :isactive=isActive :baseurl=baseurl :translations=translations :buttonsection=buttonsection> </component> <div class=infobox> <div class=nav-btn-box> <button @click=prevStep type=button class=\"prev-btn basic-bg\" v-on:touchstart=touchhover v-on:touchend=touchhoverout id=designer_main_back>zurück </button> <button v-if=\"count < (views.length-1)\" @click=nextStep class=\"next-btn basic-bg\" type=button v-on:touchstart=touchhover v-on:touchend=touchhoverout id=designer_main_forward> weiter </button> <button v-if=\"count < (views.length-1)\" @click=gotoStep(views.length-1) class=checkout-btn type=button>Jetzt Kaufen </button> </div> <div class=\"price basic-color\"> <div class=designer-price-box> <span class=cprice>{{ price }} &euro;</span> <span class=tax-details>{{{ priceInfo }}}</span> </div> </div> <div class=design-name> <div class=design-label>Design:</div> <input class=input-text type=search id=design-name maxlength=36 name=design-name v-model=designName /> <button type=button class=\"save-design basic-bg\" @click=saveDesign>speichern</button> <button type=button class=cancel-design @click=resetConfig>zurücksetzen</button> <div style=\"display: none\" v-bind:class=\"'design-name msg ' + (msg.error ? 'error' : 'success')\" id=messages> <a v-if=msg.error v-bind:href=loginurl>{{ msg.error }}</a> {{ msg.success }} </div> </div> <div class=step> <ul id=steps> <li v-for=\"(index, step) in steps\" v-if=\"index !== 14\" @click=gotoStep(index) v-bind:class=\"[ (selectBoxes[views[index]].active ? 'step-enabled' : 'step-disabled') ]\"> <span class=edit-icon></span> <span v-bind:id=index v-bind:class=\"[ 'step-name', (index === count ? 'active' : '' )]\">{{ step }}</span> </li> </ul> <span class=username></span> </div> </div> <div v-show=\"flash.error || flash.success\" v-bind:class=\"[ 'fabric-sample-popup', 'basic-bg', (flash.success ? 'flash-success' : 'flash-error')]\" id=flash> <div class=text-icon> <span class=icon></span> <div class=text>{{ flash.error }} {{ flash.success }}</div> <span class=link><a href=/shop/accessoires/stoffmuster-bestellen target=_blank>{{ translations['To swatch box'] }}</a></span> </div> </div> </div> <div v-if=\"count < (views.length-1)\" class=sticky-wrapper> <div class=\"category-description std designer-description\">{{{ seoblock }}}</div> </div> ";

/***/ }),
/* 61 */
/***/ (function(module, exports) {

	module.exports = " <div v-bind:class=\"[ 'select-col', 'component-' + box.component]\"> <div class=\"top-step-name basic-border basic-color\">{{ box.title }}</div> <div class=designer-detailbox-description> <p><span id=detail-description>{{{ box.todo }}}</span></p> </div> <div class=fabric-select-btn-box> <div class=\"top-arrow hasTop\" v-if=\"box.component == 'buttons'\"> <div class=top-arrow-text>Hochscrollen für weitere Muster</div> </div> <div :id=box.component class=fabric-select-btns> <div v-for=\"item in items\" v-bind:class=\"[ 'fabric-select-btn', isactive === item.ref_number ? 'active' : '' ]\"> <img v-bind:src=\"this.baseurl + 'media/' + item.thumb\" v-bind:alt=item.name v-bind:title=item.name v-bind:id=item.ref_number @click=updatePersonal v-bind:data-component=box.component v-bind:data-btncolor=item.color_code /> <div class=name v-bind:id=item.ref_number @click=updatePersonal v-bind:data-component=box.component v-bind:data-btncolor=item.color_code>{{ item.name }} </div> <button v-bind:class=\"[ 'zoom-btn', 'btn-standalone', (isactive === itemref_number || item.ref_number === this.personal[box.component]) ? 'active' : '' ]\" v-bind:data-refnr=item.ref_number v-bind:data-title=item.name v-bind:data-infotext=item.infotext v-bind:data-price=item.price type=button @click=zoomFabric>Details </button> </div> </div> </div> <div class=\"bottom-arrow hasTop\" v-if=\"box.component == 'buttons'\"> <div class=bottom-arrow-text>Runterscrollen für weitere Muster</div> </div> <div class=designer-select-dropdown v-if=\"personal['bags'] !== 'none'\"> <div class=designer-select-dropdown-col> <h3>Position</h3> <div id=bagsposition class=designer-select> <select title=Position id=bagsposition name=Position id=bagsposition v-model=selected @change=updatePersonalBags> <option value=left>links</option> <option value=right>rechts</option> <option value=both>beidseitig</option> </select> </div> </div> </div> </div> <zoom v-if=zoom :zoom=zoom :show.sync=show :globals=globals></zoom> ";

/***/ }),
/* 62 */
/***/ (function(module, exports) {

	module.exports = " <div v-bind:class=\"[ 'select-col', 'component-' + box.component]\"> <div class=\"top-step-name basic-border basic-color\">{{ box.title }}<span v-if=box.extra class=extra_price v-bind:style=\"[(box.extra > 0 ? {visibility: 'visible'} : {visibility: 'hidden'})]\"> + {{ box.extra }} €</span> </div> <div class=designer-detailbox-description> <p><span id=detail-description>{{{ box.todo }}}</span></p> </div> <div class=filterbox-wrapper> <div id=filterbox class=select-btn-box> <button id=button_filter_1 @click.prevent=setFilter v-bind:class=\"[ 'select-btn', 'basic-bg', (section === '1') ? 'active' : '' ]\"> <span>Standard</span></button> <button id=button_filter_3 @click.prevent=setFilter v-bind:class=\"[ 'select-btn', 'basic-bg', (section === '3') ? 'active' : '' ]\"> <span>Big Ben</span> </button> <button id=button_filter_4 @click.prevent=setFilter v-bind:class=\"[ 'select-btn', 'basic-bg', (section === '4') ? 'active' : '' ]\"> <span>Golden Gate</span></button> <button id=button_filter_5 @click.prevent=setFilter v-bind:class=\"[ 'select-btn', 'basic-bg', (section === '5') ? 'active' : '' ]\"><span>Moai</span> </button> <button id=button_filter_6 @click.prevent=setFilter v-bind:class=\"[ 'select-btn', 'basic-bg', (section === '6') ? 'active' : '' ]\"> <span>Red Fort</span></button> <button id=button_filter_7 @click.prevent=setFilter v-bind:class=\"[ 'select-btn', 'basic-bg', (section === '7') ? 'active' : '' ]\"> <span>Windsor</span> </button> <button id=button_filter_8 @click.prevent=setFilter v-bind:class=\"[ 'select-btn', 'basic-bg', (section === '8') ? 'active' : '' ]\"> <span>Magic</span> </button> </div> <div class=filter-reset-btn @click=resetFilter>Filter zurücksetzen</div> </div> <div class=fabric-select-btn-box> <div v-bind:class=\"[ 'top-arrow', 'hasTop', (scrollPosition > 0 && selectedScrollHeight > selectedClientHeight ? 'on' : '')]\" v-on:touchstart=touchstartup v-on:mouseenter=scrollup v-on:mouseleave=mouseleave v-on:touchend=touchend> <div class=top-arrow-text v-bind:style=\"[(scrollPosition > 0  && selectedScrollHeight > selectedClientHeight ? {visibility: 'visible'} : {visibility: 'hidden'})]\"> {{ translations['Scroll up for further fabrics'] }} </div> </div> <div :id=box.component class=fabric-select-btns @scroll=itemsScroll> <div v-for=\"item in items\" v-bind:class=\"[ 'fabric-select-btn', isactive === item.sku ? 'active' : '' ]\"> <img v-bind:src=\"this.baseurl + 'media/' + item.thumb\" v-bind:alt=item.name v-bind:title=item.name v-bind:id=item.sku @click=updatePersonal v-bind:data-component=box.component v-bind:data-btncolor=item.color v-bind:data-price=item.price /> <div class=name v-bind:id=item.sku @click=updatePersonal v-bind:data-component=box.component v-bind:data-btncolor=item.color v-bind:data-price=item.price>{{ item.name }} </div> <button v-bind:class=\"[ 'zoom-btn', 'btn-standalone', (isactive === item.sku || item.sku === this.personal[box.component]) ? 'active' : '' ]\" v-bind:data-refnr=item.sku v-bind:data-title=item.name v-bind:data-infotext=item.infotext v-bind:data-price=item.price type=button @click=zoomFabric>Details </button> </div> </div> </div> <div v-bind:class=\"[ 'bottom-arrow', 'hasTop', (scrollPosition < selectedScrollHeight - selectedClientHeight && selectedScrollHeight > selectedClientHeight ? '' : 'off')]\" v-on:touchstart=touchstartdown v-on:mouseenter=scrolldown v-on:mouseleave=mouseleave v-on:touchend=touchend> <div class=bottom-arrow-text v-bind:style=\"[(scrollPosition < selectedScrollHeight - selectedClientHeight && selectedScrollHeight > selectedClientHeight ? {visibility: 'visible'} : {visibility: 'hidden'})]\"> {{ translations['Scroll down for further fabrics'] }} </div> </div> </div> <zoom v-if=zoom :zoom=zoom :show.sync=show :globals=globals></zoom> ";

/***/ }),
/* 63 */
/***/ (function(module, exports) {

	module.exports = " <div v-bind:class=\"[ 'select-col', 'component-' + box.component]\"> <div class=\"top-step-name basic-border basic-color\">{{ box.title }}</div> <div class=designer-detailbox-description> <p><span id=detail-description>{{{ box.todo }}}</span></p> </div> <div class=modal-mask v-show=show transition=modal> <div class=modal-wrapper> <div class=modal-container> <div class=modal-header></div> <div class=modal-body> <div id=ajax_summary_content class=addtoCart><h1>Zusammenfassung</h1> <div class=ajax_summary_innerframe> <form v-if=items :action=items.checkoutUrl method=post id=product_addtocart_form enctype=multipart/form-data> <div class=data-table id=summary-table> <div class=row> <div class=\"sum-col header\">Attribut</div> <div class=\"sum-col header\">Konfiguration</div> </div> <div v-for=\"item in items.shirt\" v-if=\"['monogramm_prefix', 'monogramm_yarn', 'monogramm_font'].indexOf($key) < 0 \" class=row> <div class=\"sum-col attrtitle\">{{ item.cat }}</div> <div class=sum-col>{{ item.transl }}</div> </div> </div> <input v-for=\"item in items.shirt\" type=text class=\"input-text required-entry product-custom-option\" :name=\"'options['+item.id+']'\" :id=$key :value=item.val style=display:none> <div class=data-table id=my-measurementstop-table> <div class=title>Maßprofil</div> <div v-for=\"item in items.tab\" class=\"sum-col smallwidth\"> <div class=attrtitle>{{ item.head }}</div> <div>{{ item.transl }}</div> </div> </div> <input v-for=\"item in items.tab\" v-if=item.data.length type=text class=\"input-text required-entry product-custom-option\" :name=\"'options['+item.id+']'\" :id=$key :value=item.data style=display:none> <div class=summarybutton> <button class=\"button btn-cart buttonoverviewaddtocart\" title=\"In den Warenkorb\" type=button @click=this.$parent.clearViewCount()><span>In den Warenkorb</span> </button> <button class=\"button btn-cart modal-default-button\" type=button @click=\"show = false\"> {{ globals.translations['Close'] }} </button> </div> </form> <div class=modal-footer> <slot name=footer> </slot> </div> </div> </div> </div> </div> </div> </div> </div> ";

/***/ }),
/* 64 */
/***/ (function(module, exports) {

	module.exports = " <div v-bind:class=\"[ 'select-col', 'component-' + box.component]\"> <div class=\"top-step-name basic-border basic-color\">{{ box.title }}</div> <div class=designer-detailbox-description> <p><span id=detail-description>{{{ box.todo }}}</span></p> </div> <div class=fabric-select-btn-box> <div class=\"top-arrow hasTop\" v-if=\"box.component == 'buttons'\"> <div class=top-arrow-text>Hochscrollen für weitere Muster</div> </div> <div :id=box.component class=fabric-select-btns> <div v-for=\"item in items\" v-bind:class=\"[ 'fabric-select-btn', isactive === item.ref_number ? 'active' : '' ]\"> <img v-bind:src=\"this.baseurl + 'media/' + item.thumb\" v-bind:alt=item.name v-bind:title=item.name v-bind:id=item.ref_number @click=updatePersonal v-bind:data-component=box.component v-bind:data-btncolor=item.color_code /> <div class=name v-bind:id=item.ref_number @click=updatePersonal v-bind:data-component=box.component v-bind:data-btncolor=item.color_code>{{ item.name }} </div> <button v-bind:class=\"[ 'zoom-btn', 'btn-standalone', (isactive === itemref_number || item.ref_number === this.personal[box.component]) ? 'active' : '' ]\" v-bind:data-refnr=item.ref_number v-bind:data-title=item.name v-bind:data-infotext=item.infotext v-bind:data-price=item.price type=button @click=zoomFabric>Details </button> </div> </div> </div> <div class=\"bottom-arrow hasTop\" v-if=\"box.component == 'buttons'\"> <div class=bottom-arrow-text>Runterscrollen für weitere Muster</div> </div> <div class=designer-select-dropdown> <div class=designer-select-dropdown-col> <h3>{{ translations['Collar Buttons'] }}</h3> <div class=designer-select> <select title=\"{{ translations['Second Collar Button'] }}\" id=collarbuttons name=second_button v-model=selected @change=updatePersonalCollar> <option value=onebutton>{{ translations['1 Button'] }}</option> <option value=twobutton>{{ translations['2 Buttons'] }}</option> </select> </div> </div> </div> <div class=designer-select-dropdown> <div class=designer-select-dropdown-col> <h3>{{ translations['Collar Strength'] }}</h3> <div class=designer-select> <select title=\"{{ translations['Collar Strength'] }}\" id=collar_strength name=collar_strength v-model=selected_strength @change=updatePersonalCollarStrength> <option value=solid>{{ translations['solid'] }}</option> <option v-if=\"personal['collar']!='standup' && personal['collar']!='smoking'\" value=weak>{{ translations['weak'] }}</option> </select> </div> </div> </div> </div> <zoom v-if=zoom :zoom=zoom :show.sync=show :globals=globals></zoom> ";

/***/ }),
/* 65 */
/***/ (function(module, exports) {

	module.exports = " <div v-bind:class=\"[ 'select-col', 'component-' + box.component]\"> <div v-bind:class=\"[ 'mobile-fabric-preview', (currentData.ref_number !== 'none') ? 'show-border' : '']\"> <button v-if=\"currentData.ref_number !== 'none'\" type=button class=zoom-btn v-bind:data-refnr=currentData.ref_number v-bind:data-title=currentData.name v-bind:data-infotext=currentData.infotext v-bind:data-price=currentData.price v-bind:data-weave=currentData.weave v-bind:data-yarn=currentData.yarn v-bind:data-weight=currentData.weight v-bind:data-composition=currentData.composition v-bind:data-zoom=currentData.zoom @click=zoomFabric title=\"{{ translations['Further informations'] }}\">Details </button> </div> <div class=\"top-step-name basic-border basic-color\">{{ box.title }}<span v-if=box.extra class=extra_price v-bind:style=\"[((isactive !== 'none' && isactive !== personal['fabric']) ? {visibility: 'visible'} : {visibility: 'hidden'})]\"> + {{ box.extra }} €</span> </div> <div class=designer-detailbox-description> <p><span id=detail-description>{{{ box.todo }}}</span></p> </div> <filter :filtercolor=filtercolor :filterpattern=filterpattern :filterweave=filterweave :filtermaterial=filtermaterial :filteroccasion=filteroccasion :range1=range1 :range2=range2 :boolfilter=boolfilter :filtername=filtername></filter> <fabrics :baseurl=baseurl :box=box :fabrics=fabrics :filtercolor=filtercolor :filterpattern=filterpattern :filterweave=filterweave :filtermaterial=filtermaterial :filteroccasion=filteroccasion :range1=range1 :range2=range2 :boolfilter=boolfilter :fields=fields :personal=personal :filtername=filtername :muster1=muster1 :muster2=muster2 :muster3=muster3 :muster4=muster4></fabrics> <div v-if=\"['contrast_bs_bottom_outside'].indexOf(box.component) > -1\" class=preview> <img v-bind:src=\"this.baseurl + 'media/jack/shirt/detail/contrast_bs_bottom_outside.jpg'\" width=323 height=216 /> </div> <div v-if=\"['contrast_bs_upper_inside'].indexOf(box.component) > -1\" class=preview> <img v-bind:src=\"this.baseurl + 'media/jack/shirt/detail/contrast_bs_upper_inside.jpg'\" width=323 height=216 /> </div> <div v-if=\"['contrast_sleeve_buttons_outside'].indexOf(box.component) > -1\" class=preview> <img v-bind:src=\"this.baseurl + 'media/jack/shirt/detail/contrast_sleeve_buttons_outside.jpg'\" width=323 height=216 /> </div> <div v-if=\"['contrast_sleeve_buttons_inside'].indexOf(box.component) > -1\" class=preview> <img v-bind:src=\"this.baseurl + 'media/jack/shirt/detail/contrast_sleeve_buttons_inside.jpg'\" width=323 height=216 /> </div> <div v-if=\"['contrast_collar_bottom'].indexOf(box.component) > -1\" class=preview> <img v-bind:src=\"this.baseurl + 'media/jack/shirt/detail/contrast_collar_bottom.jpg'\" width=323 height=323 /> </div> <div v-if=\"['contrast_collar_stand_outer'].indexOf(box.component) > -1\" class=preview> <img v-bind:src=\"this.baseurl + 'media/jack/shirt/detail/contrast_collar_stand_outer.jpg'\" width=323 height=323 /> </div> <div v-if=\"['contrast_collar_stand_inner'].indexOf(box.component) > -1\" class=preview> <img v-bind:src=\"this.baseurl + 'media/jack/shirt/detail/contrast_collar_stand_inner.jpg'\" width=323 height=323 /> </div> </div> <zoom v-if=zoom :zoom=zoom :show.sync=show :globals=globals :muster1=muster1 :muster2=muster2 :muster3=muster3 :muster4=muster4></zoom> ";

/***/ }),
/* 66 */
/***/ (function(module, exports) {

	module.exports = " <div v-bind:class=\"[ 'select-col', 'component-' + box.component]\"> <div class=\"top-step-name basic-border basic-color\">{{ box.title }} </div> <div class=designer-detailbox-description> <p><span id=detail-description>{{{ box.todo }}}</span></p> </div> <div class=nav-btn-box> <button @click=yesAction type=button class=\"prev-btn basic-bg\">{{ translations['Yes'] }}</button> <button @click=noAction class=\"next-btn basic-bg\" type=button>{{ translations['No'] }}</button> </div> </div> ";

/***/ }),
/* 67 */
/***/ (function(module, exports) {

	module.exports = " <div v-bind:class=\"[ 'select-col', 'component-' + box.component]\"> <div class=\"top-step-name basic-border basic-color\">{{ box.title }}</div> <div class=designer-detailbox-description> <p><span id=detail-description>{{{ box.todo }}}</span></p> </div> <div class=fabric-select-btn-box> <div v-bind:class=\"[ 'top-arrow', 'hasTop', (scrollPosition > 0 && selectedScrollHeight > selectedClientHeight ? 'on' : '')]\" v-on:touchstart=touchstartup v-on:mouseenter=scrollup v-on:mouseleave=mouseleave v-on:touchend=touchend> <div class=top-arrow-text v-bind:style=\"[(scrollPosition > 0  && selectedScrollHeight > selectedClientHeight ? {visibility: 'visible'} : {visibility: 'hidden'})]\"> {{ translations['Scroll up for further fabrics'] }} </div> </div> <div :id=box.component class=fabric-select-btns> <div v-for=\"item in items\" v-bind:class=\"[ 'fabric-select-btn', isactive === item.ref_number ? 'active' : '' ]\"> <img v-bind:src=\"this.baseurl + 'media/' + item.thumb\" v-bind:alt=item.name v-bind:title=item.name v-bind:id=item.ref_number @click=updatePersonal v-bind:data-component=box.component v-bind:data-btncolor=item.color_code /> <div class=name v-bind:id=item.ref_number @click=updatePersonal v-bind:data-component=box.component v-bind:data-btncolor=item.color_code>{{ item.name }} </div> <button v-bind:class=\"[ 'zoom-btn', 'btn-standalone', (isactive === itemref_number || item.ref_number === this.personal[box.component]) ? 'active' : '' ]\" v-bind:data-refnr=item.ref_number v-bind:data-title=item.name v-bind:data-infotext=item.infotext v-bind:data-price=item.price type=button @click=zoomFabric>Details </button> </div> </div> </div> <div v-bind:class=\"[ 'bottom-arrow', 'hasTop', (scrollPosition < selectedScrollHeight - selectedClientHeight && selectedScrollHeight > selectedClientHeight ? '' : 'off')]\" v-on:touchstart=touchstartdown v-on:mouseenter=scrolldown v-on:mouseleave=mouseleave v-on:touchend=touchend> <div class=bottom-arrow-text v-bind:style=\"[(scrollPosition < selectedScrollHeight - selectedClientHeight && selectedScrollHeight > selectedClientHeight ? {visibility: 'visible'} : {visibility: 'hidden'})]\"> {{ translations['Scroll down for further fabrics'] }} </div> </div> <div class=designer-select-dropdown> <div class=designer-select-dropdown-col> <h3>{{ translations['Cuff width'] }}</h3> <p>{{ translations['Do you wear a watch under your cuff? We will make your cuff width bigger.'] }}</p> <div id=cuffwidth class=designer-select> <select title=\"{{ translations['Cuff width'] }}\" id=cuffwidth name=Manschettenweite v-model=selected @change=updatePersonalCuff> <option value=none>{{ translations['none_e'] }}</option> <option value=watchleft>{{ translations['Watch left'] }}</option> <option value=watchright>{{ translations['Watch right'] }}</option> </select> </div> </div> </div> </div> <zoom v-if=zoom :zoom=zoom :show.sync=show :globals=globals></zoom> ";

/***/ }),
/* 68 */
/***/ (function(module, exports) {

	module.exports = " <div v-bind:class=\"[ 'select-col', 'component-' + box.component]\"> <div v-bind:class=\"[ 'mobile-fabric-preview', (currentData.ref_number !== 'none') ? 'show-border' : '']\"> <button v-if=\"currentData.ref_number !== 'none'\" type=button class=zoom-btn v-bind:data-refnr=currentData.ref_number v-bind:data-title=currentData.name v-bind:data-infotext=currentData.infotext v-bind:data-price=currentData.price v-bind:data-weave=currentData.weave v-bind:data-yarn=currentData.yarn v-bind:data-weight=currentData.weight v-bind:data-composition=currentData.composition v-bind:data-zoom=currentData.zoom @click=zoomFabric title=\"{{ translations['Further informations'] }}\">Details </button> </div> <div class=\"top-step-name basic-border basic-color\">{{ box.title }}<span v-if=box.extra class=extra_price> + {{ box.extra }} €</span> </div> <div class=designer-detailbox-description> <p><span id=detail-description>{{{ box.todo }}}</span></p> </div> <filter :filtercolor=filtercolor :filterpattern=filterpattern :filterweave=filterweave :filtermaterial=filtermaterial :filteroccasion=filteroccasion :range1=range1 :range2=range2 :boolfilter=boolfilter :filtername=filtername></filter> <fabrics :baseurl=baseurl :box=box :fabrics=fabrics :filtercolor=filtercolor :filterpattern=filterpattern :filterweave=filterweave :filtermaterial=filtermaterial :filteroccasion=filteroccasion :range1=range1 :range2=range2 :boolfilter=boolfilter :fields=fields :filtername=filtername :personal=personal :muster1=muster1 :muster2=muster2 :muster3=muster3 :muster4=muster4 :showpattern=showPattern :showcolor=showColor :showweave=showWeave :showmaterial=showMaterial :showoccasion=showOccasion :showprice=showPrice :showname=showName></fabrics> <div v-if=\"currentData.ref_number !== 'none'\" class=\"preview mobile-fabric-zoom-preview\"> <img v-if=currentData.zoom v-bind:src=\"this.baseurl + 'media/'+ currentData.zoom+''\" title=\"\" alt=\"\"> </div> </div> <zoom v-if=zoom :zoom=zoom :show.sync=show :globals=globals :muster1=muster1 :muster2=muster2 :muster3=muster3 :muster4=muster4></zoom> ";

/***/ }),
/* 69 */
/***/ (function(module, exports) {

	module.exports = " <div v-bind:class=\"[ 'select-col', 'component-' + box.component]\"> <div class=\"top-step-name basic-border basic-color\">{{ box.title }}<span v-if=box.extra class=extra_price> + {{ box.extra }} €</span> </div> <div class=designer-detailbox-description> <p><span id=detail-description>{{{ box.todo }}}</span></p> </div> <div class=fabric-select-btn-box> <div :id=box.component class=fabric-select-btns> <div v-for=\"item in items\" v-bind:class=\"[ 'fabric-select-btn', isactive === item.ref_number ? 'active' : '' ]\"> <img v-bind:src=\"this.baseurl + 'media/' + item.thumb\" v-bind:alt=item.name v-bind:title=item.name v-bind:id=item.ref_number v-bind:data-component=box.component v-bind:data-btncolor=item.color_code @click=updatePersonal /> <div class=name v-bind:title=item.name v-bind:id=item.ref_number v-bind:data-component=box.component v-bind:data-btncolor=item.color_code @click=updatePersonal>{{ item.name }} </div> <button v-bind:class=\"[ 'zoom-btn', 'btn-standalone', (isactive === itemref_number || item.ref_number === this.personal[box.component]) ? 'active' : '' ]\" v-bind:data-refnr=item.ref_number v-bind:data-title=item.name v-bind:data-infotext=item.infotext v-bind:data-price=item.price type=button @click=zoomFabric>Details </button> </div> </div> </div> </div> <zoom v-if=zoom :zoom=zoom :show.sync=show :globals=globals></zoom> ";

/***/ }),
/* 70 */
/***/ (function(module, exports) {

	module.exports = " <div v-bind:class=\"[ 'select-col', 'component-' + box.component]\"> <div class=\"top-step-name basic-border basic-color\">{{ box.title }}<span v-if=box.extra class=extra_price v-bind:style=\"[(selected === 'yes' ? {visibility: 'visible'} : {visibility: 'hidden'})]\"> + {{ box.extra }} €</span> </div> <div class=designer-detailbox-description> <p><span id=detail-description>{{{ box.todo }}}</span></p> </div> <div class=fabric-select-btn-box> <div class=designer-select-dropdown> <div class=designer-select-dropdown-col> <h3>{{ translations['Hankerchief'] }}</h3> <div id=hankerchief class=designer-select> <select title=\"{{ translations['Hankerchief'] }}\" id=hankerchief name=\"{{ translations['Hankerchief'] }}\" @change=updatePersonal v-model=selected> <option value=none>{{ translations['No'] }}</option> <option value=yes>{{ translations['Yes'] }}</option> </select> </div> </div> </div> <div class=designer-select-dropdown> <div class=designer-select-dropdown-col> <p>{{ translations['Do you wish to have a tailorjack-label sewed on your shirt?'] }}</p> <h3>{{ translations['tailorjack-Logo'] }}</h3> <div id=tj_logo class=designer-select> <select title=\"{{ translations['Tailorjack-Logo'] }}\" id=tj_logo name=\"{{ translations['Tailorjack-Logo'] }}\" @change=updatePersonal v-model=selectedlogo> <option value=yes>{{ translations['Yes'] }}</option> <option value=none>{{ translations['No'] }}</option> </select> </div> </div> </div> </div> </div> ";

/***/ }),
/* 71 */
/***/ (function(module, exports) {

	module.exports = " <div v-bind:class=\"[ 'select-col', 'component-' + box.component]\"> <div class=\"top-step-name basic-border basic-color\">{{ box.title }} <span v-if=box.extra class=extra_price v-bind:style=\"[(message !== '' ? {visibility: 'visible'} : {visibility: 'hidden'})]\"> + {{ box.extra }} €</span> </div> <div class=designer-detailbox-description> <p><span id=detail-description>{{{ box.todo }}}</span></p> </div> <div class=fabric-select-btn-box> <div class=designer-select-dropdown> <div class=designer-select-dropdown-col> <h3><span id=detail-name>Text</span></h3> <div id=monogramm> <input class=input-text type=search id=monogramm maxlength=6 title=Monogramm name=Monogramm v-model=message @keyup=updatePersonalMonogramm> <button class=\"reset-btn basic-bg\" type=button @click=resetMonogramm>X</button> </div> </div> <div class=designer-select-dropdown-col> <h3>Schriftart</h3> <div id=monogramm_font class=designer-select> <select title=Schriftart id=monogramm_font name=Schriftart v-model=fontselect @change=updatePersonalMonogramm> <option value=block>Block</option> <option value=italic>Kursiv</option> </select> </div> </div> <div class=designer-select-dropdown-col> <h3>Position</h3> <div id=monopos class=designer-select> <select title=Position id=monopos name=Position v-model=selected @change=updatePersonalMonogramm> <option value=waistleft>{{ translations['Waist left'] }}</option> <option value=waistright>{{ translations['Waist right'] }}</option> <option v-if=\"personal['sleeve']!='short' && personal['sleeve']!='shortbar'\" value=cuffleft>{{ translations['Cuff left'] }} </option> <option v-if=\"personal['sleeve']!='short' && personal['sleeve']!='shortbar'\" value=cuffright>{{ translations['Cuff right'] }} </option> <option value=collarleft>{{ translations['Collar left'] }}</option> <option value=collarright>{{ translations['Collar right'] }}</option> <option v-if=\"personal['bags']!='none' && personal['bagsposition']!='right'\" value=pocketleft>{{ translations['Pocket left'] }} </option> <option v-if=\"personal['bags']!='none' && personal['bagsposition']!='left'\" value=pocketright>{{ translations['Pocket right'] }} </option> </select> </div> </div> </div> <div class=designer-select-picturebox> <h3>Garn</h3> <div class=fabric-select-btn-box> <div v-bind:class=\"[ 'top-arrow', 'hasTop', (scrollPosition > 0 && selectedScrollHeight > selectedClientHeight ? 'on' : '')]\" v-on:touchstart=touchstartup v-on:mouseenter=scrollup v-on:mouseleave=mouseleave v-on:touchend=touchend> <div class=top-arrow-text v-bind:style=\"[(scrollPosition > 0  && selectedScrollHeight > selectedClientHeight ? {visibility: 'visible'} : {visibility: 'hidden'})]\"> {{ translations['Scroll up for further fabrics'] }} </div> </div> <div id=monogramm_yarn class=fabric-select-btns v-el:yarns @scroll=itemsScroll> <div v-for=\"item in fabrics\" v-bind:class=\"[ 'fabric-select-btn', isactive === item.color_code ? 'active' : '' ]\" v-bind:data-yarncolor=item.color_code @click=updatePersonal data-component=monogramm_yarn v-bind:id=item.color_code> <div class=fabric-select-img> <span class=mask></span> <img v-bind:src=imgUrl(item.color_code) v-bind:alt=item.name v-bind:title=item.name /> </div> <div class=name>{{ item.name }}</div> </div> </div> </div> <div v-bind:class=\"[ 'bottom-arrow', 'hasTop', (scrollPosition < selectedScrollHeight - selectedClientHeight && selectedScrollHeight > selectedClientHeight ? '' : 'off')]\" v-on:touchstart=touchstartdown v-on:mouseenter=scrolldown v-on:mouseleave=mouseleave v-on:touchend=touchend> <div class=bottom-arrow-text v-bind:style=\"[(scrollPosition < selectedScrollHeight - selectedClientHeight && selectedScrollHeight > selectedClientHeight ? {visibility: 'visible'} : {visibility: 'hidden'})]\"> {{ translations['Scroll down for further fabrics'] }} </div> </div> </div> </div> </div> ";

/***/ }),
/* 72 */
/***/ (function(module, exports) {

	module.exports = " <div v-bind:class=\"[ 'select-col', 'component-' + box.component]\"> <div class=\"top-step-name basic-border basic-color\">{{ box.title }}<span v-if=box.extra class=extra_price v-bind:style=\"[(isactive !== 'neutral' ? {visibility: 'visible'} : {visibility: 'hidden'})]\"> + {{ box.extra }} €</span> </div> <div class=designer-detailbox-description> <p><span id=detail-description>{{{ box.todo }}}</span></p> </div> <div class=fabric-select-btn-box> <div v-bind:class=\"[ 'top-arrow', 'hasTop', (scrollPosition > 0 && selectedScrollHeight > selectedClientHeight ? 'on' : '')]\" v-on:touchstart=touchstartup v-on:mouseenter=scrollup v-on:mouseleave=mouseleave v-on:touchend=touchend> <div class=top-arrow-text v-bind:style=\"[(scrollPosition > 0  && selectedScrollHeight > selectedClientHeight ? {visibility: 'visible'} : {visibility: 'hidden'})]\"> {{ translations['Scroll up for further fabrics'] }} </div> </div> <div id=\"{{ box.component }}\" class=fabric-select-btns @scroll=itemsScroll> <div v-for=\"item in fabrics\" v-bind:class=\"[ 'fabric-select-btn', isactive === item.color_code ? 'active' : '' ]\" v-bind:id=item.color_code @click=updatePersonal v-bind:data-component=box.component v-bind:data-yarncolor=item.color_code> <div class=fabric-select-img> <span class=mask></span> <img v-bind:src=imgUrl(item.color_code) v-bind:alt=item.name v-bind:title=item.name /> </div> <div class=name>{{ item.name }}</div> </div> </div> </div> <div v-bind:class=\"[ 'bottom-arrow', 'hasTop', (scrollPosition < selectedScrollHeight - selectedClientHeight && selectedScrollHeight > selectedClientHeight ? '' : 'off')]\" v-on:touchstart=touchstartdown v-on:mouseenter=scrolldown v-on:mouseleave=mouseleave v-on:touchend=touchend> <div class=bottom-arrow-text v-bind:style=\"[(scrollPosition < selectedScrollHeight - selectedClientHeight && selectedScrollHeight > selectedClientHeight ? {visibility: 'visible'} : {visibility: 'hidden'})]\"> {{ translations['Scroll down for further fabrics'] }} </div> </div> <div v-if=\"['yarncontrast'].indexOf(box.component) > -1\" class=preview> <img v-bind:src=\"this.baseurl + 'media/jack/shirt/detail/yarncontrast.jpg'\" width=323 height=323 /> </div> </div> ";

/***/ }),
/* 73 */
/***/ (function(module, exports) {

	module.exports = " <div class=fabric-select-btn-box> <div v-bind:class=\"[ 'top-arrow', 'hasTop', (scrollPosition > 0 && selectedScrollHeight > selectedClientHeight ? 'on' : '')]\" v-on:touchstart=touchstartup v-on:mouseenter=scrollup v-on:mouseleave=mouseleave v-on:touchend=touchend> <div class=top-arrow-text v-bind:style=\"[(scrollPosition > 0  && selectedScrollHeight > selectedClientHeight ? {visibility: 'visible'} : {visibility: 'hidden'})]\"> {{ translations['Scroll up for further fabrics'] }} </div> </div> <div id=\"{{ box.component }}\" class=fabric-select-btns @scroll=itemsScroll> <div v-for=\"button in fabrics | filterBy filtercolor in 'color' | filterBy filterpattern in 'pattern' | filterBy filterweave in 'weave'| filterBy filtermaterial in 'material' | filterBy filteroccasion in 'occasion' | filterBy priceBetween | filterBy newFilter | filterBy topseller | filterBy filtername in 'name'\" class=fabric-select-btn> <div class=fabric-select-img> <span v-bind:class=\"[ 'mask', (isactive === button.ref_number || button.ref_number === this.personal[box.component] || (button.ref_number === 'none' && this.personal[box.component] === 'neutral')) ? 'active' : '' ]\" v-bind:id=button.ref_number @click=updatePersonal v-bind:data-component=box.component v-bind:data-fabric_quality=button.quality v-bind:data-price=button.price></span> <img v-bind:src=\"this.baseurl + 'media/'+ button.thumb+''\" alt=\"\" v-bind:title=button.name v-bind:class=active /> </div> <div class=name v-bind:id=button.ref_number @click=updatePersonal v-bind:data-component=box.component v-bind:data-fabric_quality=button.quality v-bind:data-price=button.price>{{ button.name }} </div> <button v-if=\"button.ref_number !== 'none'\" v-bind:class=\"[ 'zoom-btn', 'btn-standalone', (isactive === button.ref_number || button.ref_number === this.personal[box.component]) ? 'active' : '' ]\" type=button @click=zoomFabric v-bind:data-refnr=button.ref_number v-bind:data-title=button.name v-bind:data-infotext=button.infotext v-bind:data-price=button.price v-bind:data-weave=button.weave v-bind:data-yarn=button.yarn v-bind:data-weight=button.weight v-bind:data-composition=button.composition v-bind:data-zoom=button.zoom title=\"{{ translations['Further informations'] }}\">Details </button> </div> </div> </div> <div v-bind:class=\"[ 'bottom-arrow', 'hasTop', (scrollPosition < selectedScrollHeight - selectedClientHeight && selectedScrollHeight > selectedClientHeight ? '' : 'off')]\" v-on:touchstart=touchstartdown v-on:mouseenter=scrolldown v-on:mouseleave=mouseleave v-on:touchend=touchend> <div class=bottom-arrow-text v-bind:style=\"[(scrollPosition < selectedScrollHeight - selectedClientHeight && selectedScrollHeight > selectedClientHeight ? {visibility: 'visible'} : {visibility: 'hidden'})]\"> {{ translations['Scroll down for further fabrics'] }} </div> </div> <zoom v-if=zoom :zoom=zoom :show.sync=show :globals=globals :muster1=muster1 :muster2=muster2 :muster3=muster3 :muster4=muster4></zoom> ";

/***/ }),
/* 74 */
/***/ (function(module, exports) {

	module.exports = " <div class=filterbox-wrapper> <div id=filterbox class=select-btn-box> <button id=colorButton @click.prevent=showFilter v-bind:class=\"[ 'select-btn', 'basic-bg', (filtercolor === '' || typeof filtercolor === 'undefined' ? '' : 'active'), classcolor]\"> <span>{{ buttonColor }}</span> </button> <div v-show=showColor id=colorFilter class=select-btn-box> <button data-select=color id=white @click.prevent=setFilter class=\"select-btn basic-bg\"><span>{{ translations['White'] }}</span> </button> <button data-select=color id=blue @click.prevent=setFilter class=\"select-btn basic-bg\"><span>{{ translations['Blue'] }}</span> </button> <button data-select=color id=black @click.prevent=setFilter class=\"select-btn basic-bg\"><span>{{ translations['Black'] }}</span> </button> <button data-select=color id=pink @click.prevent=setFilter class=\"select-btn basic-bg\"><span>{{ translations['Pink'] }}</span> </button> <button data-select=color id=grey @click.prevent=setFilter class=\"select-btn basic-bg\"><span>{{ translations['Grey'] }}</span> </button> <button data-select=color id=brown @click.prevent=setFilter class=\"select-btn basic-bg\"><span>{{ translations['Brown'] }}</span> </button> <button data-select=color id=red @click.prevent=setFilter class=\"select-btn basic-bg\"><span>{{ translations['Red'] }}</span> </button> <button data-select=color id=others @click.prevent=setFilter class=\"select-btn basic-bg\"><span>{{ translations['Others'] }}</span> </button> <button data-select=color id=all @click.prevent=setFilter class=\"select-btn basic-bg\"><span>{{ translations['All'] }}</span> </button> </div> <button id=patternButton @click.prevent=showFilter v-bind:class=\"[ 'select-btn', 'basic-bg', (filterpattern === '' || typeof filterpattern === 'undefined' ? '' : 'active'), classpattern]\"> <span>{{ buttonPattern }}</span></button> <div v-show=showPattern id=patternFilter class=select-btn-box> <button data-select=pattern id=chambray @click.prevent=setFilter class=\"select-btn basic-bg\"> <span>{{ translations['Chambray Look'] }}</span></button> <button data-select=pattern id=checks @click.prevent=setFilter class=\"select-btn basic-bg\"><span>{{ translations['Checks'] }}</span> </button> <button data-select=pattern id=dots @click.prevent=setFilter class=\"select-btn basic-bg\"><span>{{ translations['Dots'] }}</span> </button> <button data-select=pattern id=heringbone @click.prevent=setFilter class=\"select-btn basic-bg\"> <span>{{ translations['Heringbone'] }}</span></button> <button data-select=pattern id=plain @click.prevent=setFilter class=\"select-btn basic-bg\"><span>{{ translations['Plain'] }}</span> </button> <button data-select=pattern id=stripes @click.prevent=setFilter class=\"select-btn basic-bg\"><span>{{ translations['Stripes'] }}</span> </button> <button data-select=pattern id=all @click.prevent=setFilter class=\"select-btn basic-bg\"><span>{{ translations['All'] }}</span> </button> </div> <button id=priceButton @click.prevent=showFilter v-bind:class=\"[ 'select-btn', 'basic-bg', (range1.value !== range1.min || range2.value !== range2.max) ? 'active' : '' ]\"> <span>{{ buttonPrice }}</span></button> <div v-show=showPrice id=priceFilter class=select-btn-box> <span class=close @click.prevent=closePrice>x</span> <button data-start=49 data-end=70 @click.prevent=setPriceRange class=\"select-btn basic-bg\">49 - 70 €</button> <button data-start=71 data-end=90 @click.prevent=setPriceRange class=\"select-btn basic-bg\">71 - 90 €</button> <button data-start=91 data-end=100 @click.prevent=setPriceRange class=\"select-btn basic-bg\">91 - 100 €</button> <button data-start=49 data-end=100 @click.prevent=setPriceRange class=\"select-btn basic-bg\">{{ translations['All'] }}</button> </div> <button id=weaveButton @click.prevent=showFilter v-bind:class=\"[ 'select-btn', 'basic-bg', (filterweave === '' || typeof filterweave === 'undefined' ? '' : 'active'), classweave]\"> <span>{{ buttonWeave }}</span> </button> <div v-show=showWeave id=weaveFilter class=select-btn-box> <button data-select=weave id=dobby @click.prevent=setFilter class=\"select-btn basic-bg\"><span>{{ translations['Dobby'] }}</span> </button> <button data-select=weave id=fil-a-fil @click.prevent=setFilter class=\"select-btn basic-bg\"><span>{{ translations['Fil-a-Fil'] }}</span> </button> <button data-select=weave id=heringbone @click.prevent=setFilter class=\"select-btn basic-bg\"> <span>{{ translations['Heringbone'] }}</span></button> <button data-select=weave id=chambray @click.prevent=setFilter class=\"select-btn basic-bg\"><span>{{ translations['Chambray'] }}</span> </button> <button data-select=weave id=lacoste @click.prevent=setFilter class=\"select-btn basic-bg\"><span>{{ translations['Lacoste'] }}</span> </button> <button data-select=weave id=poplin @click.prevent=setFilter class=\"select-btn basic-bg\"><span>{{ translations['Poplin'] }}</span> </button> <button data-select=weave id=twill @click.prevent=setFilter class=\"select-btn basic-bg\"><span>{{ translations['Twill'] }}</span> </button> <button data-select=weave id=all @click.prevent=setFilter class=\"select-btn basic-bg\"><span>{{ translations['All'] }}</span> </button> </div> <button id=materialButton @click.prevent=showFilter v-bind:class=\"[ 'select-btn', 'basic-bg', (filtermaterial === '' || typeof filtermaterial === 'undefined' ? '' : 'active'), classmaterial]\"> <span>{{ buttonMaterial }}</span> </button> <div v-show=showMaterial id=materialFilter class=select-btn-box> <button data-select=material id=100%_cotton @click.prevent=setFilter class=\"select-btn basic-bg\"> <span>{{ translations['100% Cotton'] }}</span></button> <button data-select=material id=cotton_blend @click.prevent=setFilter class=\"select-btn basic-bg\"> <span>{{ translations['Cotton Blend'] }}</span></button> <button data-select=material id=all @click.prevent=setFilter class=\"select-btn basic-bg\"><span>{{ translations['All'] }}</span> </button> </div> <button id=new @click.prevent=setBoolFilter v-bind:class=\"[ 'select-btn', 'basic-bg', (boolfilter['new'] !== '1' ? '' : 'active')]\"><span>{{ buttonNew }}</span> </button> <button id=topseller @click.prevent=setBoolFilter v-bind:class=\"[ 'select-btn', 'basic-bg', (boolfilter['topseller'] !== '1' ? '' : 'active')]\"> <span>{{ buttonTopseller }}</span></button> <button id=occasionButton @click.prevent=showFilter v-bind:class=\"[ 'select-btn', 'basic-bg', (filteroccasion === '' || typeof filteroccasion === 'undefined' ? '' : 'active'), classoccasion]\"> <span>{{ buttonOccasion }}</span></button> <div v-show=showOccasion id=occasionFilter class=select-btn-box> <button data-select=occasion id=all_occasions @click.prevent=setFilter class=\"select-btn basic-bg\"><span>{{ translations['All Occassions'] }}</span></button> <button data-select=occasion id=business_festive @click.prevent=setFilter class=\"select-btn basic-bg\"><span>{{ translations['Business & Festive'] }}</span></button> <button data-select=occasion id=business_festive_casual @click.prevent=setFilter class=\"select-btn basic-bg\"><span>{{ translations['Business & Festive/ Casual'] }}</span> </button> <button data-select=occasion id=leisure_festive @click.prevent=setFilter class=\"select-btn basic-bg\"><span>{{ translations['Leisure & Festive'] }}</span></button> <button data-select=occasion id=leisure_casual @click.prevent=setFilter class=\"select-btn basic-bg\"><span>{{ translations['Leisure/ Casual'] }}</span></button> <button data-select=occasion id=all @click.prevent=setFilter class=\"select-btn basic-bg\"><span>{{ translations['All'] }}</span> </button> </div> <button id=nameButton @click.prevent=showFilter v-bind:class=\"[ 'select-btn', 'basic-bg', (filtername === '' || typeof filtername === 'undefined' ? '' : 'active')]\"> <span>{{ buttonName }}</span> </button> <div v-show=showName id=nameFilter class=select-btn-box> <span class=close @click.prevent=closeName>x</span> <label>{{ translations['Name'] }}</label> <div class=name-text> <input type=text data-select=name v-model=filtername @keyup=nameChange autofocus> </div> </div> </div> </div> <div class=filter-reset-btn @click=realResetFilter>{{translations['Reset filter']}}</div> ";

/***/ }),
/* 75 */
/***/ (function(module, exports) {

	module.exports = " <div v-if=zoom class=modal-mask v-show=show transition=modal> <div class=modal-wrapper> <div class=modal-fabric-container> <button class=modal-close-button @click=\"this.show = false\">schließen</button> <div v-if=zoom.img class=modal-image v-bind:style=\"'background-image: url( '+ zoom.img +' )'\"></div> <div class=modal-text> <div class=modal-titlebox> <div class=modal-title>{{ zoom.title }}</div> <div v-if=zoom.composition class=modal-subtitle>{{ translations[zoom.composition] }}</div> </div> <p>{{ zoom.infotext }}</p> <div class=price v-if=\"zoom.price > 0\"> {{ zoom.price }} &euro;</div> <div class=info-itembox> <div class=info-item v-if=\"zoom.weight > 0\"> <div class=info-title>Gewicht</div> <div class=info-icon> <div class=darkbg></div> <div class=mask v-bind:style=\"{ bottom: bottomWeight + '%' }\"></div> <img :src=globals.imgweight alt=\"\"/></div> <span>{{ zoom.weight }} g</span> </div> <div class=info-item v-if=zoom.yarn> <div class=info-title>Garn</div> <div class=\"info-icon garn\"><img :src=globals.imggarn alt=\"\"/></div> <span>{{ translations[zoom.yarn] }}</span> </div> <div class=info-item v-if=zoom.weave> <div class=info-title>Webart</div> <div class=\"info-icon webart\"><img :src=globals.imgweave alt=\"\"/></div> <span>{{ translations[zoom.weave] }}</span> </div> </div> </div> </div> </div> </div> ";

/***/ }),
/* 76 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_script__, __vue_template__
	var __vue_styles__ = {}
	__webpack_require__(59)
	__vue_script__ = __webpack_require__(15)
	__vue_template__ = __webpack_require__(60)
	module.exports = __vue_script__ || {}
	if (module.exports.__esModule) module.exports = module.exports.default
	var __vue_options__ = typeof module.exports === "function" ? (module.exports.options || (module.exports.options = {})) : module.exports
	if (__vue_template__) {
	__vue_options__.template = __vue_template__
	}
	if (!__vue_options__.computed) __vue_options__.computed = {}
	Object.keys(__vue_styles__).forEach(function (key) {
	var module = __vue_styles__[key]
	__vue_options__.computed[key] = function () { return module }
	})


/***/ }),
/* 77 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_script__, __vue_template__
	var __vue_styles__ = {}
	__vue_script__ = __webpack_require__(16)
	__vue_template__ = __webpack_require__(61)
	module.exports = __vue_script__ || {}
	if (module.exports.__esModule) module.exports = module.exports.default
	var __vue_options__ = typeof module.exports === "function" ? (module.exports.options || (module.exports.options = {})) : module.exports
	if (__vue_template__) {
	__vue_options__.template = __vue_template__
	}
	if (!__vue_options__.computed) __vue_options__.computed = {}
	Object.keys(__vue_styles__).forEach(function (key) {
	var module = __vue_styles__[key]
	__vue_options__.computed[key] = function () { return module }
	})


/***/ }),
/* 78 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_script__, __vue_template__
	var __vue_styles__ = {}
	__vue_script__ = __webpack_require__(17)
	__vue_template__ = __webpack_require__(62)
	module.exports = __vue_script__ || {}
	if (module.exports.__esModule) module.exports = module.exports.default
	var __vue_options__ = typeof module.exports === "function" ? (module.exports.options || (module.exports.options = {})) : module.exports
	if (__vue_template__) {
	__vue_options__.template = __vue_template__
	}
	if (!__vue_options__.computed) __vue_options__.computed = {}
	Object.keys(__vue_styles__).forEach(function (key) {
	var module = __vue_styles__[key]
	__vue_options__.computed[key] = function () { return module }
	})


/***/ }),
/* 79 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_script__, __vue_template__
	var __vue_styles__ = {}
	__vue_script__ = __webpack_require__(18)
	__vue_template__ = __webpack_require__(63)
	module.exports = __vue_script__ || {}
	if (module.exports.__esModule) module.exports = module.exports.default
	var __vue_options__ = typeof module.exports === "function" ? (module.exports.options || (module.exports.options = {})) : module.exports
	if (__vue_template__) {
	__vue_options__.template = __vue_template__
	}
	if (!__vue_options__.computed) __vue_options__.computed = {}
	Object.keys(__vue_styles__).forEach(function (key) {
	var module = __vue_styles__[key]
	__vue_options__.computed[key] = function () { return module }
	})


/***/ }),
/* 80 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_script__, __vue_template__
	var __vue_styles__ = {}
	__vue_script__ = __webpack_require__(19)
	__vue_template__ = __webpack_require__(64)
	module.exports = __vue_script__ || {}
	if (module.exports.__esModule) module.exports = module.exports.default
	var __vue_options__ = typeof module.exports === "function" ? (module.exports.options || (module.exports.options = {})) : module.exports
	if (__vue_template__) {
	__vue_options__.template = __vue_template__
	}
	if (!__vue_options__.computed) __vue_options__.computed = {}
	Object.keys(__vue_styles__).forEach(function (key) {
	var module = __vue_styles__[key]
	__vue_options__.computed[key] = function () { return module }
	})


/***/ }),
/* 81 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_script__, __vue_template__
	var __vue_styles__ = {}
	__vue_script__ = __webpack_require__(20)
	__vue_template__ = __webpack_require__(65)
	module.exports = __vue_script__ || {}
	if (module.exports.__esModule) module.exports = module.exports.default
	var __vue_options__ = typeof module.exports === "function" ? (module.exports.options || (module.exports.options = {})) : module.exports
	if (__vue_template__) {
	__vue_options__.template = __vue_template__
	}
	if (!__vue_options__.computed) __vue_options__.computed = {}
	Object.keys(__vue_styles__).forEach(function (key) {
	var module = __vue_styles__[key]
	__vue_options__.computed[key] = function () { return module }
	})


/***/ }),
/* 82 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_script__, __vue_template__
	var __vue_styles__ = {}
	__vue_script__ = __webpack_require__(21)
	__vue_template__ = __webpack_require__(66)
	module.exports = __vue_script__ || {}
	if (module.exports.__esModule) module.exports = module.exports.default
	var __vue_options__ = typeof module.exports === "function" ? (module.exports.options || (module.exports.options = {})) : module.exports
	if (__vue_template__) {
	__vue_options__.template = __vue_template__
	}
	if (!__vue_options__.computed) __vue_options__.computed = {}
	Object.keys(__vue_styles__).forEach(function (key) {
	var module = __vue_styles__[key]
	__vue_options__.computed[key] = function () { return module }
	})


/***/ }),
/* 83 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_script__, __vue_template__
	var __vue_styles__ = {}
	__vue_script__ = __webpack_require__(22)
	__vue_template__ = __webpack_require__(67)
	module.exports = __vue_script__ || {}
	if (module.exports.__esModule) module.exports = module.exports.default
	var __vue_options__ = typeof module.exports === "function" ? (module.exports.options || (module.exports.options = {})) : module.exports
	if (__vue_template__) {
	__vue_options__.template = __vue_template__
	}
	if (!__vue_options__.computed) __vue_options__.computed = {}
	Object.keys(__vue_styles__).forEach(function (key) {
	var module = __vue_styles__[key]
	__vue_options__.computed[key] = function () { return module }
	})


/***/ }),
/* 84 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_script__, __vue_template__
	var __vue_styles__ = {}
	__vue_script__ = __webpack_require__(23)
	__vue_template__ = __webpack_require__(68)
	module.exports = __vue_script__ || {}
	if (module.exports.__esModule) module.exports = module.exports.default
	var __vue_options__ = typeof module.exports === "function" ? (module.exports.options || (module.exports.options = {})) : module.exports
	if (__vue_template__) {
	__vue_options__.template = __vue_template__
	}
	if (!__vue_options__.computed) __vue_options__.computed = {}
	Object.keys(__vue_styles__).forEach(function (key) {
	var module = __vue_styles__[key]
	__vue_options__.computed[key] = function () { return module }
	})


/***/ }),
/* 85 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_script__, __vue_template__
	var __vue_styles__ = {}
	__vue_script__ = __webpack_require__(24)
	__vue_template__ = __webpack_require__(69)
	module.exports = __vue_script__ || {}
	if (module.exports.__esModule) module.exports = module.exports.default
	var __vue_options__ = typeof module.exports === "function" ? (module.exports.options || (module.exports.options = {})) : module.exports
	if (__vue_template__) {
	__vue_options__.template = __vue_template__
	}
	if (!__vue_options__.computed) __vue_options__.computed = {}
	Object.keys(__vue_styles__).forEach(function (key) {
	var module = __vue_styles__[key]
	__vue_options__.computed[key] = function () { return module }
	})


/***/ }),
/* 86 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_script__, __vue_template__
	var __vue_styles__ = {}
	__vue_script__ = __webpack_require__(25)
	__vue_template__ = __webpack_require__(70)
	module.exports = __vue_script__ || {}
	if (module.exports.__esModule) module.exports = module.exports.default
	var __vue_options__ = typeof module.exports === "function" ? (module.exports.options || (module.exports.options = {})) : module.exports
	if (__vue_template__) {
	__vue_options__.template = __vue_template__
	}
	if (!__vue_options__.computed) __vue_options__.computed = {}
	Object.keys(__vue_styles__).forEach(function (key) {
	var module = __vue_styles__[key]
	__vue_options__.computed[key] = function () { return module }
	})


/***/ }),
/* 87 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_script__, __vue_template__
	var __vue_styles__ = {}
	__vue_script__ = __webpack_require__(26)
	__vue_template__ = __webpack_require__(71)
	module.exports = __vue_script__ || {}
	if (module.exports.__esModule) module.exports = module.exports.default
	var __vue_options__ = typeof module.exports === "function" ? (module.exports.options || (module.exports.options = {})) : module.exports
	if (__vue_template__) {
	__vue_options__.template = __vue_template__
	}
	if (!__vue_options__.computed) __vue_options__.computed = {}
	Object.keys(__vue_styles__).forEach(function (key) {
	var module = __vue_styles__[key]
	__vue_options__.computed[key] = function () { return module }
	})


/***/ }),
/* 88 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_script__, __vue_template__
	var __vue_styles__ = {}
	__vue_script__ = __webpack_require__(27)
	__vue_template__ = __webpack_require__(72)
	module.exports = __vue_script__ || {}
	if (module.exports.__esModule) module.exports = module.exports.default
	var __vue_options__ = typeof module.exports === "function" ? (module.exports.options || (module.exports.options = {})) : module.exports
	if (__vue_template__) {
	__vue_options__.template = __vue_template__
	}
	if (!__vue_options__.computed) __vue_options__.computed = {}
	Object.keys(__vue_styles__).forEach(function (key) {
	var module = __vue_styles__[key]
	__vue_options__.computed[key] = function () { return module }
	})


/***/ })
]);


// WEBPACK FOOTER //
// static/js/app.f830d3759c09aac00cdf.js